import { Injectable } from '@angular/core';
import { setDefaultOptions, loadModules } from 'esri-loader';
import {SclUtilMapService} from './scl-util-map.service';
import {SclProjectionConstantService} from './scl-projection-constant.service';
import {SclMapViewsService} from './scl-map-views.service';
import {SclMapConstantService} from './scl-map-constant.service';
import {SclAssetLayersService} from './scl-asset-layers.service';
import * as cloneDeep from 'lodash/cloneDeep';

const sclMapConstant = SclMapConstantService;
const sclMapViews = new SclMapViewsService();
const sclAssetLayers = new SclAssetLayersService();
const sclProjectionConstant = SclProjectionConstantService;

setDefaultOptions({ css: true });

@Injectable({
  providedIn: 'root'
})
export class SclMappingFunctionsArcGisService {

  constructor() { }

  sclUtilMapService = new SclUtilMapService();
  lib;
  map;
  mapView;
  layer0;

  divWrapper;
  selectedAssets = [];
  selectedFeatures = [];
  setDirtyFunction;
  type; // 0: sc-boundary, 1: sc-address-map, 2: sc-street-address, 3: sc-selected-asset
  setupMapDone;
  selectionStyle;
  primaryAssetSelection; secondaryAssetSelection;
  layersRedraw;
  heightNum;
  mapId;
  onTilesLoaded;
  zoomFloor = 18; // 14254
  tileLayers;
  addressImageAnchor; primaryImageAnchor; secondaryImageAnchor;
  layerAssets = [];
  layerIndexFilter; layerIndexSecondary; layerIndexPrimary; layerIndexUser; layerIndexAddress; layerIndexTooltips; layerIndexControl;
  compActionType = ''; // 14310: '' = no action, 'primary', 'secondary', ....
  ActionControls = [];
  lstHeatWeight = []; heatDatas = []; heatLayerConfig = {};
  divZoomIn; divZoomOut; // zoom in/out button
  fitCoors = []; // map has call fitCoordsAction or not
  mapLoaded = false; // map hasn't load successfull
  drawingMode = 'single'; color = 'black'; multiColor = 'red'; tempColor; finalColor; drawBtn; sketchViewModel; editGraphic ;
  drawingShapeSingle = []; drawingShapeMulti = { point: [], line: [], polygon: []} ; // for sc-boundary
  defaultZoom; defaultLat; defaultLon;
  textSymbolVerticalAlignment = ['baseline', 'top', 'middle', 'bottom'];
  textSymbolHorizontalAlignment = ['left', 'right', 'center', 'justify'];
  isMapReady = false;
  controlBtns = []; elementCtrl;
  testDiv; marker; psmaReverse; multipleSelection; fitCoordCount; initialZoomChange;
  modeLabel;
  actionType;  interactionDraw; funcSingleSelectMode;
  customControlHeight; divControlElement; isBottom;
  divCustomControl;
  toolTipOnFeatureHover; setupTooltipUI; mouseHoverFeature = null;
  fullScreenEvent; mapDiv; // 15336#c59379

  load(cb) {
    this.lib = {};
    loadModules(['esri/Map',
      'esri/views/MapView',
      'esri/views/SceneView',
      'esri/layers/FeatureLayer',
      'esri/layers/GraphicsLayer',
      'esri/Graphic',
      'esri/core/watchUtils',
      'esri/geometry/support/webMercatorUtils',
      'esri/Color',
      'esri/geometry/Multipoint',
      'esri/geometry/Circle',
      'esri/geometry/Point',
      'esri/symbols/Font',
      'esri/symbols/TextSymbol',
      'esri/widgets/Fullscreen',
      'esri/geometry/Extent',
      'esri/widgets/Sketch/SketchViewModel', ])
      .then(([Map, MapView, SceneView, FeatureLayer, GraphicsLayer, Graphic, watchUtils, webMercatorUtils, Color, Multipoint, Circle, Point,
               Font, TextSymbol, Fullscreen, Extent, SketchViewModel]) => {
        this.lib = {
          Map, MapView, SceneView, FeatureLayer, GraphicsLayer, Graphic, watchUtils, webMercatorUtils, Color, Multipoint, Circle, Point,
          Font, TextSymbol, Fullscreen, Extent, SketchViewModel
        };
        if (cb && typeof cb === 'function') {
          cb();
        }
      }).catch( () => {
      if (cb && typeof cb === 'function') {
        cb();
      }
    });
  }

 interactionSelect() {
    // TO DO
  }

  interactionModify() {
    // TO DO
  }

  interactionSelectMultiple(isActive, cb) {
    // TO DO
  }

  checkGeoJson(geojson) {
    if (typeof geojson.features === 'undefined' || geojson.features.length == null || geojson.features.length === 0) { return false; }
    const f0 = geojson.features[0];
    if ( typeof f0.type !== 'undefined' && typeof f0.geometry !== 'undefined'
      && typeof f0.geometry.type !== 'undefined') { return true; }

    return false;
  }

  clampZoomFloor() {
    if (this.mapView.zoom > this.zoomFloor) {
      this.mapView.goTo({
        zoom: this.zoomFloor
      });
    }
  }

  getTile(mapView, isShow, self) {
    const tile = '';
    // TO DO

    return tile;
  }

  multiLayers(mapViews) {
    return [];
  }

  // copy from sclUtilMap
  setView(lng, lat, zoom, EPSG, minResolution, maxResolution, maxZoom) {
    // TO DO
    // return view;
  }

  createLayerSourceNormal(zIndex, pStyle, title, layerDisplayOnly) {
    let objStyle = {
      color: 'black',
      fill: null,
      fillOpacity: 1,
      lineCap: null,
      lineDash: null,
      lineWidth: 1,
      imageAnchor: [0.5, 0.5],
      imageFileNo: ''
    };
    if (pStyle) {
      objStyle = {
        color: (pStyle.color ? pStyle.color : 'black'),
        fill: (pStyle.fill ? pStyle.fill : null),
        fillOpacity: (pStyle.fillOpacity ? pStyle.fillOpacity : 1),
        lineCap: (pStyle.lineCap ? pStyle.lineCap : null),
        lineDash: (pStyle.lineDash ? pStyle.lineDash : null),
        lineWidth: (pStyle.lineWidth ? pStyle.lineWidth : 1),
        imageAnchor: (pStyle.imageAnchor ? pStyle.imageAnchor : [0.5, 0.5] ),
        imageFileNo: (pStyle.imageFileNo ? pStyle.imageFileNo : '')
      };
    }
    return {
      graphicLayer: new this.lib.GraphicsLayer(),
      zIndex,
      style: objStyle,
      title,
      layerDisplayOnly
    };
  }

  createEmptyLayer(zIndex, pStyle, title, isHeatMap, options) {
    let newLayer;
    let layerDisplayOnly = false;
    if (options && options.layerDisplayOnly) { layerDisplayOnly = options.layerDisplayOnly; }
    if (isHeatMap) {
      const renderer = {
        type: 'heatmap',
        field: 'weight',
        colorStops: [
          { ratio: 0, color: 'rgba(255, 140, 0, 0)' },
          { ratio: 0.75, color: 'rgba(255, 140, 0, 1)' },
          { ratio: 0.9, color: 'rgba(255, 0,   0, 1)' }
        ],
        minPixelIntensity: 0,
        maxPixelIntensity: 100,
        blurRadius: 10
      };
      if (options != null && typeof options.gradient !== 'undefined') {
        renderer.colorStops = [];
        const factor = parseFloat( (1 / options.gradient.length).toFixed(2) );
        let ratio = 0;
        for (let i = 0; i < options.gradient.length; i++) {
          renderer.colorStops.push({ ratio, color: options.gradient[i] });
          ratio += factor;
          if (ratio > 1) { ratio = 1; }
        }
      }
      if (options != null && typeof options.blur !== 'undefined') { renderer.blurRadius = options.blur; }
      const aLayer = new this.lib.FeatureLayer(
        {
          fields: [
            {
              name: 'id',
              alias: 'id',
              type: 'string'
            },
            {
              name: 'weight',
              alias: 'weight',
              type: 'double'
            }
          ],
          objectIdField: 'id',
          geometryType: 'point',
          // spatialReference: view.spatialReference,
          renderer ,
          source: []
        }
      );
      newLayer = {
        graphicLayer: aLayer,
        zIndex,
        isHeatMap: true,
        layerDisplayOnly: true
      };
    } else {
      newLayer = this.createLayerSourceNormal(zIndex, pStyle, title, layerDisplayOnly);
    }
    newLayer.layerQuery = options;
    return newLayer;
  }

  createLayerAsset(options) {
    // 1) UI controls (zoom, map selector. etc)
    // 2) Tooltips, other popup controls
    // 3) User added items : address pins, selections, etc
    // 4) Objects returned from "primaryAssetFilter"
    // 5) Objects returned from "secondaryAssetFilter"
    // 6) Objects returned from a "filter" query at the root of the component
    // 7) Items returned from the layers[0] entry
    // 8) items returned from layers[1] entry
    // 9) Items returned from layers[n] entry, where n is the last layer in the array
    // 10) Base map images
    let layerQuery = []; let hasFilterQuery = false; let hasSecondary = false; let styleSecondary = null; let hasPrimary = false;
    let stylePrimary = null; let hasUserItems = false; let styleSelected = null; let hasAddressPoint = false; let stylePoint = null;
    if (options.layerQuery) { layerQuery = options.layerQuery; }
    if (options.hasFilterQuery) { hasFilterQuery = options.hasFilterQuery; }
    if (options.hasSecondary) { hasSecondary = options.hasSecondary; }
    if (options.styleSecondary) { styleSecondary = options.styleSecondary; }
    if (options.hasPrimary) { hasPrimary = options.hasPrimary; }
    if (options.stylePrimary) { stylePrimary = options.stylePrimary; }
    if (options.hasUserItems) { hasUserItems = options.hasUserItems; }
    if (options.styleSelected) { styleSelected = options.styleSelected; }
    if (options.hasAddressPoint) { hasAddressPoint = options.hasAddressPoint; }
    if (options.stylePoint) { stylePoint = options.stylePoint; }

    let layerIndex = 0;
    if (this.layerAssets == null) { this.layerAssets = []; }
    if (layerQuery) {// 9,8,7
      for (let i = 0; i < layerQuery.length; i++) {
        if (layerQuery[i].query.indexOf('_layer') < 0) {
          continue;
        }
        let style = {};
        if (layerIndex < layerQuery.length) { style = layerQuery[layerIndex].layer; }
        layerIndex++;

        this.layerAssets.push(this.createEmptyLayer(layerIndex, style, 'layer' + layerIndex, layerQuery[i].isHeatMap, layerQuery[i].layer));
      }
    }
    if (hasFilterQuery) {// 6
      let style = {};
      if (layerIndex < layerQuery.length) { style = layerQuery[layerIndex].layer; }
      layerIndex++;

      this.layerAssets.push(this.createEmptyLayer(layerIndex, style , 'filter', null, null));
      this.layerIndexFilter = layerIndex;
    }
    if (hasSecondary) {// 5
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, this.convertStylePrimary(styleSecondary, 'secondary') ,
        'secondary', null, null));
      this.layerIndexSecondary = layerIndex;
    }
    if (hasPrimary) {// 4
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, this.convertStylePrimary(stylePrimary, 'primary'), 'primary', null, null));
      this.layerIndexPrimary = layerIndex;
    }

    if (hasUserItems) {// 3
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, this.convertStylePrimary(styleSelected,  '') , 'selectedItems', null, null));
      this.layerIndexUser = layerIndex;
    }
    if (hasAddressPoint) {// 3
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, stylePoint, 'addressPoint', null, null));
      this.layerIndexAddress = layerIndex;
    }
    // tooltips
    this.layerIndexTooltips = layerIndex + 1;
    // controls button
    this.layerIndexControl = layerIndex + 2;
  }

  convertStylePrimary(style, type) {
    let defaultImgFileNo = sclMapConstant.MAP_MARKER;
    if (type === 'primary') { defaultImgFileNo = sclMapConstant.MAP_PRIMARY_ASSET;
    } else if (type === 'secondary') { defaultImgFileNo = sclMapConstant.MAP_SECONDARY_ASSET; }
    let imgFileNo = style.selectionImageFileNo;
    if (imgFileNo && imgFileNo !== sclMapConstant.MAP_MARKER &&
      imgFileNo !== sclMapConstant.MAP_PRIMARY_ASSET && imgFileNo !== sclMapConstant.MAP_SECONDARY_ASSET) {
      imgFileNo = '/api/getFile/' + imgFileNo.replace('api/getFile/', '').replace('/api/getFile/', '');
    }
    return {
      color: (style.selectionColor ? style.selectionColor : 'black'),
      fill: (style.selectionFill ? style.selectionFill : null),
      fillOpacity: ( style.selectionFillOpacity ? style.selectionFillOpacity : 1),
      lineCap: ( style.selectionLineCap ? style.selectionLineCap : null ),
      lineDash: ( style.selectionLineDash ? style.selectionLineDash : null ),
      lineWidth: ( style.selectionLineWidth ? style.selectionLineWidth : 1 ),
      imageAnchor: ( style.selectionImageAnchor ? style.selectionImageAnchor : [0.5, 0.5 ] ),
      imageFileNo: ( imgFileNo ? imgFileNo : defaultImgFileNo )
    };
  }

  createLayers(initObj) {
    this.layerAssets = [];
    this.layerAssets.push(this.createLayerSourceNormal(0, {}, 'layer0', false));

    let layerQuery = [];
    if (this.type === 0) {// sc-boundary
      this.createLayerAsset({ layerQuery, hasAddressPoint: true, stylePoint: initObj.styleAddress });
    } else if (this.type === 1) {// sc-address-map
      if (initObj.layerAssets) {
        layerQuery = initObj.layerAssets;
      }
      this.createLayerAsset({ layerQuery, hasFilterQuery: true, hasUserItems: true, styleSelected: initObj.selectionStyle });
    } else if (this.type === 2) {// sc-street-address
      this.createLayerAsset({ layerQuery, hasAddressPoint: true, stylePoint: initObj.styleAddress } );
    } else if (this.type === 3) {// sc-selected-asset
      if (initObj.layerAssets) {
        layerQuery = initObj.layerAssets;
      }
      this.createLayerAsset({ layerQuery, hasFilterQuery: true
        , hasSecondary: true, styleSecondary: initObj.secondaryAssetSelection
        , hasPrimary: true, stylePrimary: initObj.primaryAssetSelection
        , hasAddressPoint: true, stylePoint: initObj.styleAddress } );
    }

  }

  createHeatMap(layerIndex) {

    const min = Math.min.apply(null, this.lstHeatWeight);
    const max = Math.max.apply(null, this.lstHeatWeight);
    const addFeatures = [];
    for (let i = 0; i < this.heatDatas.length; i++) {
      let weight = (this.heatDatas[i].weight - min) / (max - min); // clamp weight 0..1

      if (isNaN(weight)) {
        if (max === min) { weight = 1; } else {  weight = 0; }
      }
      if (weight > 1) { weight = 1; }
      // created for owl range of data
      const coord = this.heatDatas[i].location;
      const pf = {
        geometry: {
          type: 'point',
          longitude: coord[0],
          latitude: coord[1]
        }
      };
      this.heatDatas[i].weight = weight;
      this.setFeatureProperties(pf, this.heatDatas[i]);
      addFeatures.push(pf);
    }

    this.heatDatas = []; // reset
    this.lstHeatWeight = []; // reset

    this.layerAssets[layerIndex].graphicLayer.applyEdits({
      addFeatures
    });
  }

  init(initObj) {
    this.divWrapper = initObj.divWrapper;
    this.selectedAssets = [];

    if (initObj.setDirty) { this.setDirtyFunction = initObj.setDirty; }

    this.type = initObj.style;
    let coordinates;
    if (initObj.formatGeoJSON) {// use for sc-boundary
      coordinates = initObj.formatGeoJSON;
    }
    if (initObj.setupMapDone) { this.setupMapDone = initObj.setupMapDone; }


    // 13835

    if (initObj.selectionStyle) { this.selectionStyle = initObj.selectionStyle; }
    if (initObj.primaryAssetSelection) { this.primaryAssetSelection = initObj.primaryAssetSelection; }
    if (initObj.secondaryAssetSelection) { this.secondaryAssetSelection = initObj.secondaryAssetSelection; }
    if (initObj.color) { this.color = initObj.color; }
    if (initObj.multiColor) { this.multiColor = initObj.multiColor; }
    if (initObj.setDirty) { this.setDirtyFunction = initObj.setDirty; }
    if (initObj.layersRedraw) { this.layersRedraw = initObj.layersRedraw; }
    if (initObj.heightNum) { this.heightNum = initObj.heightNum; }
    if (initObj.mapId) { this.mapId = initObj.mapId; }
    if (initObj.onTilesLoaded) { this.onTilesLoaded = initObj.onTilesLoaded; }
    if (initObj.singleSelectMode) { this.funcSingleSelectMode = initObj.singleSelectMode; }
    if (initObj.zoomFloor) { this.zoomFloor = initObj.zoomFloor; }
    if (initObj.layers) { this.tileLayers = initObj.layers; }
    if (initObj.toolTipOnFeatureHover) { this.toolTipOnFeatureHover = initObj.toolTipOnFeatureHover; }
    if (initObj.setupTooltipUI) { this.setupTooltipUI = initObj.setupTooltipUI; }
    if (initObj.fullScreenEvent) { this.fullScreenEvent = initObj.fullScreenEvent; }
    if (initObj.target) { this.mapDiv = initObj.target; }

    this.defaultLat = (initObj.defaultLat ? initObj.defaultLat : -37.8);
    this.defaultLon = (initObj.defaultLon ? initObj.defaultLon : 144.9);
    this.defaultZoom = (initObj.defaultZoom ? initObj.defaultZoom : 14);

    this.drawingShapeMulti = { point: [], line: [], polygon: []};

    this.map = new this.lib.Map({
      basemap: 'topo-vector'
    });

    this.mapView = new this.lib.MapView({
      container: initObj.target,
      map: this.map,
      center: [this.defaultLon, this.defaultLat],
      zoom: this.defaultZoom,
      // navigation: {
      //     mouseWheelZoomEnabled: scrollWheel
      // }
    });

    if (initObj.disableMouseWheel) {
      this.mapView.on('mouse-wheel', function(event) {
        // prevents zooming with the mouse-wheel event
        event.stopPropagation();
      });
    }

    if (initObj.style === 0) {
      if (coordinates && this.checkGeoJson(coordinates)) {
        // TO DO : draw asset/add feature by geo json
      }

    } else if (initObj.style === 1) {// sc-address-map

    } else if (initObj.style === 2) {
      if (coordinates && this.checkGeoJson(coordinates)) {
        // TO DO : draw asset/add feature by geo json
      }
    } else if (initObj.style === 3) {
      this.addressImageAnchor = initObj.addressImageAnchor;
      this.primaryImageAnchor = initObj.primaryImageAnchor;
      this.secondaryImageAnchor = initObj.secondaryImageAnchor;

      if (coordinates && this.checkGeoJson(coordinates)) {
        // TO DO : draw asset/add feature by geo json
      }
    }
    this.createLayers(initObj);

    // TO DO
    // let mZoom = (this.type == 1 ? 12 : 19);//13885 && 13924-2
    // this.view = this.setView(lon, lat, zoom, this.EPSG, initObj.minResolution, initObj.maxResolution, mZoom);//

    if (coordinates) {
      this.clampZoomFloor();
    }

    // TO DO
    // let controls = (initObj.controls) ? initObj.controls : [];
    // this.map = this.initializeMap(initObj.configService, controls, initObj.target, this.view
    //     , initObj.interactions, initObj.disableMouseWheel, null , this.tileLayers);

    for (let i = 0; i < this.layerAssets.length; i++) {
      this.map.add(this.layerAssets[i].graphicLayer, i);
    }



    const fullscreen = new this.lib.Fullscreen({
      view: this.mapView
    });
    this.mapView.ui.add(fullscreen, 'top-right');
    // detect fullscreen mode
    this.lib.watchUtils.watch(fullscreen.viewModel, 'state', (value) => {
      let isFullScreen = false;
      if (value === 'ready') {
        initObj.target.style.width = '100%';
        initObj.target.style.height = '100%';
      } else if (value === 'active') {
        isFullScreen = true;
      }
      if (!this.isBottom) {
        this.elementCtrl.style.top = ((initObj.target.offsetHeight - 45) / 2 - (this.customControlHeight / 2)) + 'px';
      }
      if (this.fullScreenEvent != null && typeof this.fullScreenEvent === 'function') {
        this.fullScreenEvent(this.mapDiv.offsetHeight, isFullScreen);
      }
    });



    // //test test zoom in/out button when clicking
    // this.mapView.watch('zoom', function(newValue) {
    this.lib.watchUtils.watch(this.mapView, 'zoom', (newValue) => {
      if (this.divZoomIn) {
        this.divZoomIn.title = 'Zoom In (' + newValue + ')';
      }
      if (this.divZoomOut) {
        this.divZoomOut.title = 'Zoom Out (' + newValue + ')';
      }

      for (let i = 1; i < this.layerAssets.length; i++) {
        if (this.isHeatLayer(i) || !this.layerAssets[i].layerQuery || !this.layerAssets[i].layerQuery.labelDisplayZoom) {
          continue;
        } // heat map and not effect by labelDisplayZoom

        const labelDisplayZoom = this.layerAssets[i].layerQuery.labelDisplayZoom;
        if ( labelDisplayZoom > newValue ) {
          this.layerAssets[i].graphicLayer.graphics.forEach((feature) => {
            if (feature.attributes && feature.attributes.lb ) {
              feature.attributes.lb.symbol.text = '';
            }
          });
        } else {
          this.layerAssets[i].graphicLayer.graphics.forEach((feature) => {
            if (feature.attributes && feature.attributes.lb ) {
              feature.attributes.lb.symbol.text = feature.attributes.label.labelText;
            }
          });
        }

      }

      if (this.type === 1) {
        this.showHeatLayer(newValue);
      }

    });


    this.mapView.ui.move('zoom', 'bottom-right');
    this.mapView.when(function() {
      // This function will execute once the promise is resolved
      console.log('view loaded successfully');
      if (this.setupTooltipUI && (typeof this.setupTooltipUI === 'function')) {
        this.setupTooltipUI();
        this.setupTooltipUI = null; // call one time when init map
    }

      if (this.type === 0) {// sc-boundary
        const pointSymbol = {
          type: 'simple-marker', // autocasts as new SimpleMarkerSymbol()
          style: 'circle',
          color: this.color,
          size: '16px',
          outline: { // autocasts as new SimpleLineSymbol()
            color: this.color,
            width: 1
          }
        };

        const polylineSymbol = {
          type: 'simple-line', // autocasts as new SimpleLineSymbol()
          color: this.color,
          width: '4',
          style: 'solid',
          outline: { // autocasts as new SimpleLineSymbol()
            color: this.color,
            width: 1
          }
        };

        const polygonSymbol = {
          type: 'simple-fill', // autocasts as new SimpleFillSymbol()
          color: this.color,
          style: 'solid',
          outline: {
            color: this.color,
            width: 1
          }
        };

        // create a new sketch view model
        this.layerAssets[0].graphicLayer.id = 'tempGraphics';

        this.sketchViewModel = new this.lib.SketchViewModel({
          view: this.mapView,
          layer: this.layerAssets[0].graphicLayer,
          updateOnGraphicClick: false,
          pointSymbol,
          polylineSymbol,
          polygonSymbol
        });
        this.finalColor = this.color;
        this.tempColor = 'blue';
        this.setSketchColor(this.tempColor, this.finalColor);

        if (coordinates && coordinates.features) {// initObj.formatGeoJSON
          let fullExtent = null;
          try {
              for (let i = 0; i < coordinates.features.length; i++) {
                  const json = coordinates.features[i];
                  const type = json.geometry.type;
                  let idx = i + '';
                  let extent = null;
                  if (type === 'Point') {
                      let g1: any = this.createPointNormal(json.geometry.coordinates[0], json.geometry.coordinates[1], pointSymbol);
                      g1 = this.sketchItemSetAttribute(g1, 'single', this.color, 'blue' , idx);
                      this.sketchViewModel.layer.add(g1);
                      this.drawingShapeSingle.push(g1);
                      extent = new this.lib.Extent({
                        xmin: g1.geometry.x, ymin: g1.geometry.y,
                        xmax: g1.geometry.x, ymax: g1.geometry.y
                      });
                      if (extent) {
                          if (!fullExtent) {
                            fullExtent = extent.clone();
                          } else {
                            fullExtent.union(extent);
                          }
                      }
                  } else if (type === 'LineString') {
                      let g2 = this.createLineNormal(json.geometry.coordinates, polylineSymbol);
                      g2.geometry = this.lib.webMercatorUtils.geographicToWebMercator(g2.geometry);
                      g2 = this.sketchItemSetAttribute(g2, 'single', this.color, 'blue', idx);
                      this.sketchViewModel.layer.add(g2);
                      this.drawingShapeSingle.push(g2);
                      extent = g2.geometry.extent;
                      if (extent) {
                          if (!fullExtent) {
                            fullExtent = extent.clone();
                          } else {
                            fullExtent.union(extent);
                          }
                      }
                  } else if (type === 'Polygon') {
                      let g3 = this.createPolygonNormal(json.geometry.coordinates, polygonSymbol);
                      g3.geometry = this.lib.webMercatorUtils.geographicToWebMercator(g3.geometry);
                      g3 = this.sketchItemSetAttribute(g3, 'single', this.color, 'blue', idx);
                      this.sketchViewModel.layer.add(g3);
                      this.drawingShapeSingle.push(g3);
                      extent = g3.geometry.extent;
                      if (extent) {
                          if (!fullExtent) {
                              fullExtent = extent.clone();
                          } else {
                              fullExtent.union(extent);
                          }
                      }
                  } else if (type === 'MultiPoint') {
                      for (let j1 = 0; j1 < json.geometry.coordinates.length; j1++) {
                          idx = idx + j1;
                          const coor = json.geometry.coordinates[j1];
                          let g4 = this.createPointNormal(coor[0], coor[1], pointSymbol);
                          g4.symbol.color = this.multiColor;
                          g4.symbol.outline.color = this.multiColor;
                          g4 = this.sketchItemSetAttribute(g4, 'multi', this.multiColor, 'green', idx);
                          this.sketchViewModel.layer.add(g4);
                          this.drawingShapeMulti.point.push(g4);
                          extent = new this.lib.Extent({
                              xmin: g4.geometry.x, ymin: g4.geometry.y,
                              xmax: g4.geometry.x, ymax: g4.geometry.y
                          });
                          if (extent) {
                              if (!fullExtent) {
                                  fullExtent = extent.clone();
                              } else {
                                  fullExtent.union(extent);
                              }
                          }
                      }
                  } else if (type === 'MultiLineString') {
                      for (let j2 = 0; j2 < json.geometry.coordinates.length; j2++) {
                          idx = idx + j2;
                          const coor = json.geometry.coordinates[j2];
                          let g5 = this.createLineNormal(coor, polylineSymbol);
                          g5.geometry = this.lib.webMercatorUtils.geographicToWebMercator(g5.geometry);
                          g5.symbol.color = this.multiColor;
                          g5.symbol.outline.color = this.multiColor;
                          g5 = this.sketchItemSetAttribute(g5, 'multi', this.multiColor, 'green', idx);
                          this.sketchViewModel.layer.add(g5);
                          this.drawingShapeMulti.line.push(g5);
                          extent = g5.geometry.extent;
                          if (extent) {
                              if (!fullExtent) {
                                  fullExtent = extent.clone();
                              } else {
                                  fullExtent.union(extent);
                              }
                          }
                      }
                  } else if (type === 'MultiPolygon') {
                      for (let j = 0; j < json.geometry.coordinates.length; j++) {
                          idx = idx + j;
                          const coor = json.geometry.coordinates[j];
                          let g = this.createPolygonNormal(coor, polygonSymbol);
                          g.geometry = this.lib.webMercatorUtils.geographicToWebMercator(g.geometry);
                          g.symbol.color = this.multiColor;
                          g.symbol.outline.color = this.multiColor;
                          g = this.sketchItemSetAttribute(g, 'multi', this.multiColor, 'green', idx);
                          this.sketchViewModel.layer.add(g);
                          this.drawingShapeMulti.polygon.push(g);
                          extent = g.geometry.extent;
                          if (extent) {
                              if (!fullExtent) {
                                  fullExtent = extent.clone();
                              } else {
                                  fullExtent.union(extent);
                              }
                          }
                      }
                  }
              }

              if (fullExtent) {
                  fullExtent.spatialReference = this.mapView.spatialReference;
                  this.mapView.goTo(fullExtent);
              }
          } catch (err) {
            console.log(err);
          }
      }

        // Listen to create-complete event to add a newly created graphic to view
        this.sketchViewModel.on('create', (event) => {
          if (event.state === 'complete') {
            // console.log('create');
            const idx = (new Date()).toISOString();
            event.graphic = this.sketchItemSetAttribute(event.graphic, this.drawingMode, this.finalColor, this.tempColor, idx);
            // console.log(event);
            if (this.drawingMode === 'single') {
              this.drawingShapeSingle.push(event.graphic);
            } else {
              const geomType = event.graphic.geometry.type;

              if (geomType === 'point') {
                this.drawingShapeMulti.point.push(event.graphic);
              } else if (geomType === 'polyline') {
                this.drawingShapeMulti.line.push(event.graphic);
                // console.log('polyline, coords = ' + event.graphic.geometry.paths);
              } else if (geomType === 'polygon') {
                this.drawingShapeMulti.polygon.push(event.graphic);
                // console.log('polyline, coords = ' + event.graphic.geometry.rings);
              }
            }
            if (this.drawBtn) {
              this.drawBtn.click();
              setTimeout(() => {
                  this.drawBtn.click();
              }, 100);
            }
            if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function') {
                this.setDirtyFunction();
            }
          }
        });

        // Listen the sketchViewModel's update-complete and update-cancel events
        this.sketchViewModel.on('update', (event) => {
          if (this.actionType === 'select') {
            // console.log(event);
            // console.log('this.sketchViewModel.updateGraphics.length = ' + this.sketchViewModel.updateGraphics.length);
            if (this.sketchViewModel.updateGraphics.length !== 1 || event.tool == null) {
                this.sketchViewModel.complete();
                // this.sketchViewModel.cancel();
                this.editGraphic = null;
                // console.log('%c ***** CANCEL EDIT', 'color:blue');
                return;
            }
            if (event.state === 'complete' || event.state === 'cancel') {
                this.editGraphic = null;
                // console.log('%c |===> set this.editGraphic = null here', 'color:blue');
            }
            if ( (event.state === 'start' || event.state === 'complete' || event.state === 'cancel')
            && this.setDirtyFunction && typeof this.setDirtyFunction === 'function') {
                this.setDirtyFunction();
            }
            return;
          } else {
            console.log('invalid action for sc-boundary');
          }
        });
      }

      this.mapLoaded = true;


      const findBtnZoom = setInterval(() => {
        this.divZoomIn = document.querySelector('[title="Zoom in"]');
        // console.log('findBtnZoom, this.divZoomIn = ' + this.divZoomIn);
        if (this.divZoomIn) {
          clearInterval(findBtnZoom);

          this.divZoomIn.title = 'Zoom In (' + this.mapView.zoom + ')';

          this.divZoomOut = document.querySelector('[title="Zoom out"]');
          this.divZoomOut.title = 'Zoom Out (' + this.mapView.zoom + ')';
        }

      }, 200);


      // if map have custom control then add custom control to map
      if (this.ActionControls.length > 0) {
        const height = 32; const width = 32; // default button of arc is 32 x 32 px

        this.divCustomControl = document.createElement('DIV');
        this.divCustomControl.id = 'customControl';

        this.customControlHeight = 0;

        this.isBottom = false;
        if (this.type === 0 && this.heightNum < 3 || (this.type === 3 &&  this.heightNum === 1)) {// sc-boundary
          this.isBottom = true;
        }

        for (let i = 0; i < this.ActionControls.length; i++) {
          for (let j = 0; j < this.ActionControls[i].childNodes.length; j++) {
            for (let k = 0; k < this.ActionControls[i].childNodes[j].childNodes.length; k++) {
              this.ActionControls[i].childNodes[j].childNodes[k].style.width = width + 'px';
              this.ActionControls[i].childNodes[j].childNodes[k].style.height = height + 'px';
            }
            this.customControlHeight += this.ActionControls[i].childNodes[j].childNodes.length * height;
            if (this.isBottom) {
              this.ActionControls[i].childNodes[j].style.display = 'flex';
            } else {
              this.ActionControls[i].childNodes[j].style.display = 'grid';
            }
            this.divCustomControl.appendChild(this.ActionControls[i].childNodes[j]);
          }
        }
        initObj.target.appendChild(this.divCustomControl);
        // this.customControlHeight /= 2;
        // console.log('%c this.customControlHeight = ' + this.customControlHeight, 'color:blue');
        this.elementCtrl.classList.add('gis-custom-control'); // must define this class in css of each component
        if (this.isBottom) {
          const css = {
            // position: 'relative',
            'z-index': 1000,
            // , left: '10px'
            width : this.elementCtrl.offsetWidth + 'px'
            // , height: height + 'px'
            // , bottom: '35px'
            // , display: 'flex'
          };
          Object.assign(this.divCustomControl.style, css);
          this.mapView.ui.add(this.divCustomControl, 'bottom-left');
        } else {
          const css = {
            // position: 'absolute',
            'z-index': 1000,
            // , left: '10px'
            height : this.elementCtrl.offsetHeight + 'px'
            // , width: width + 'px'
            // , top: (this.mapView.height - 45 - this.customControlHeight / 2) + 'px'
            // , display: 'grid'
          };
          Object.assign(this.divCustomControl.style, css);
          this.mapView.ui.add(this.divCustomControl, 'top-left');
          this.elementCtrl.style.top = ((this.mapView.height - 45) / 2 - (this.customControlHeight / 2)) + 'px';
        }
      }
      if (this.fitCoors) {
        this.fitCoordsAction();
        if (this.type === 2 && this.marker) {
          //     this.mapView.center = [this.marker.geometry.longitude, this.marker.geometry.latitude];
          //     this.mapView.zoom = 18;
          this.clampZoomFloor();
        }
      }

      //
      if (this.setupMapDone && typeof this.setupMapDone === 'function') {
        this.setupMapDone();
      }

      // if(this.onTilesLoaded && typeof this.onTilesLoaded === 'function'){
      //     this.onTilesLoaded();
      // }
      this.isMapReady = true;
    }.bind(this)).catch(function(err) {
      console.log(err);
    });
  }
  createPointNormal(lon, lat, symbol) {
    const g = new this.lib.Graphic({
        geometry: {
            type: 'point',
            longitude: lon,
            latitude: lat,
            spatialReference: this.mapView.spatialReference
        },
        symbol: symbol
    });
    return g;
  }
  createLineNormal(coords, symbol) {
    const g = new this.lib.Graphic({
        geometry: {
            type: 'polyline',
            paths: coords,
            spatialReference: this.mapView.spatialReference
        },
        symbol: symbol
    });
    return g;
  }
  createPolygonNormal(coords, symbol) {
    const g = new this.lib.Graphic({
        geometry: {
            type: 'polygon',
            rings: coords,
            spatialReference: this.mapView.spatialReference
        },
        symbol: symbol
    });
    return g;
  }
  sketchItemSetAttribute(graphic, realType, finalColor, tempColor, idx) {
    graphic.attributes = {
        finalColor: finalColor,
        tempColor: tempColor,
        realType: realType,
        idx: idx
    };

    return graphic;
  }

  showHeatLayer(zoom) {
    // if we have heat map and zoomLevel
    for (const f in this.heatLayerConfig) {
      if (this.heatLayerConfig[f].zoomLevel) {
        if (zoom < this.heatLayerConfig[f].zoomLevel) {
          this.layerAssets[f].graphicLayer.visible = false;
        } else {
          this.layerAssets[f].graphicLayer.visible = true;
        }
      }
    }
  }
  checkIsFullScreenSupport() {
    const body: any = document.body;
    return !!(
        body.webkitRequestFullscreen ||
        (body.mozRequestFullScreen ) ||
        (body.msRequestFullscreen ) ||
        (body.requestFullscreen )
    );
  }

  mapMoveEnd(moveEndFunc) {
    // detect when map is moved
    this.lib.watchUtils.whenTrue(this.mapView, 'stationary', () => {
      // Get the new extent of view/map whenever map is updated.
      if (this.mapView.extent) {
        const debugleftTop = this.lib.webMercatorUtils.xyToLngLat(this.mapView.extent.xmin, this.mapView.extent.ymin);
        const debugrightBottom = this.lib.webMercatorUtils.xyToLngLat(this.mapView.extent.xmax, this.mapView.extent.ymax);
        console.log('%c MAP IS MOVED, min = ' + debugleftTop + ', max = '
          + debugrightBottom, 'color:blue');
        if (this.fitCoors && this.fitCoors.length > 0) {
          this.fitCoors = null; // reset
          let currentZoom = this.mapView.zoom;
          if (this.type === 3) {// sc-selected-asset
            if (this.fitCoordCount === 1) {
              currentZoom = currentZoom - 2;
              if (currentZoom < 0) { currentZoom = 1; }
              this.mapView.zoom = currentZoom;
            }
          } else if (this.type === 1) {// sc-address-map
            if (this.initialZoomChange && this.initialZoomChange !== 0) {
              currentZoom += this.initialZoomChange;
              this.mapView.zoom = currentZoom;
            }
          }

          if (this.mapView.zoom < 0) { this.mapView.zoom = 1; }
          console.log('%c after FIT, zoom = ' + this.mapView.zoom, 'color:blue');
          this.clampZoomFloor();
          console.log('%c |===> after clampZoomFloor, zoom = ' + this.mapView.zoom, 'color:blue');
        }

        if (moveEndFunc && typeof moveEndFunc === 'function') {
          moveEndFunc();
        }
      }
    });

    // this.mapView.on("pointer-up", function(evt){
    //     if(moveEndFunc && typeof moveEndFunc === 'function'){
    //         moveEndFunc();
    //     }
    // });

  }

  createTextStyle(label, color, type) {

    // TO DO
  }

  getAnchor(icon, anchor) {
    if (( icon === sclMapConstant.MAP_MARKER || icon === sclMapConstant.MAP_PRIMARY_ASSET
      || icon === sclMapConstant.MAP_SECONDARY_ASSET ) && anchor == null) {
      anchor = [0.5, 1.0]; // system defined Images
    }
    if (anchor == null) { anchor = [0.5, 0.5]; }// no image anchor & is override image

    return anchor;
  }

  // copy from sclStyleUtil
  getPointStyle(color, icon, imageAnchor, geom, label, t) {
    // TO DO
  }
  getMultiPointStyle(properties) {
    // TO DO
  }
  getLineStyle(pColor, properties, geom, t) {
    // TO DO
  }
  lableStyle(geom, label, color, t) {
    // TO DO
  }

  colorWithAlpha(color, alpha) {
    // TO DO
  }

  addStyleControlButton(btn) {
    btn.onmouseover = function() {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'lightgrey';
    };
    btn.onmouseout = function() {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'white';
    };
  }

  initializeMap(ConfigService, controls, target, view, interactions, disableMouseWheel, mapLayers, multiLayers) {
    // TO DO
  }

  addInteractionSnap() {
    // TO DO
  }
  removeInteractionSnap() {
    // TO DO
  }
  drawDefaultStyle(drawStart, drawEnd) {
    // TO DO
  }

  drawPrimaryStyle(drawStart, drawEnd) {
    // TO DO
  }

  drawCustomStyle(drawStart, drawEnd) {
    // TO DO
  }

  addInteractionDraw( drawStart, drawEnd) {
    if (drawStart && drawEnd) {
      this.interactionDraw = this.mapView.on('click', (event) => {
        this.mapView.hitTest(event.screenPoint).then((response) => {
          const features = [];
          const graphics = response.results;
          graphics.forEach((graphic) => {
            const att = graphic.graphic.attributes;
            if (att && att.isAsset && !att.layerDisplayOnly ) {
              features.push(graphic.graphic);
            }
          });
          const mp = this.lib.webMercatorUtils.webMercatorToGeographic(event.mapPoint);
          const obj = {event, clickFeature: features, latLng: { lat: mp.y, lng: mp.x }};
          drawStart(obj);
          drawEnd(obj);

        });
      });
    }
  }

  removeInteractionDraw() {
    if (this.interactionDraw) {
      this.interactionDraw.remove();
    }

  }
  // use for sc-address-map
  setLayerSelectAsset(event) {
    const style = this.layerAssets[this.layerIndexUser].style;
    this.mapView.hitTest(event.screenPoint).then((response) => {
      let fs = [];
      if (this.multipleSelection) {
        const graphics = response.results;
        graphics.forEach((graphic) => {
          const att = graphic.graphic.attributes;
          if (att && att.isAsset && !att.layerDisplayOnly ) {
            fs.push(graphic.graphic);
          }
        });
        fs = this.getFeaturesCollection({feature: fs});
        if (fs.length > 0) {
          let isDirty = false;
          let lstAdd = [];
          let isRemove = false;
          for (let i = 0; i < fs.length; i++) {
            const f = fs[i].feature;
            const fId = this.getFeatureId(f);
            let added = false;
            let lb;
            for (let k = this.selectedFeatures.length - 1; k > -1; k--) {
              const kId = this.getFeatureId(this.selectedFeatures[k]);
              if (kId === fId ) {
                added = true;
                if (f.attributes.zIndex === this.layerIndexUser) {
                  isRemove = true;
                  this.selectedFeatures.splice(k, 1);
                  if (f.attributes.lb) {
                    lb = f.attributes.lb;
                  }
                  this.layerAssets[this.layerIndexUser].graphicLayer.graphics.remove(f);

                }
                // break;
              }
            }
            if (added) {
              lstAdd = []; // quit this forEach ignore add feature logic then call setDirtyFunction
            } else {
              lstAdd.push(f);
            }
          }
          if (isRemove) {
            isDirty = true;
            lstAdd = []; // quit this forEach ignore add feature logic then call setDirtyFunction
          }

          lstAdd.forEach((f, j) => {
            const g = f.clone();
            g.attributes.zIndex = this.layerIndexUser;
            if (g.attributes.type === 'Point' || g.attributes.type === 'MultiPoint') {
              if (style.imageFileNo) {
                g.symbol.url = style.imageFileNo;
              }
            }
            if (g.attributes.lb) {
              delete g.attributes.lb;
            }
            this.selectedFeatures.push(g);
            this.addFeature(g, this.layerIndexUser);
            isDirty = true;

          });

          if (isDirty && this.setDirtyFunction) {
            this.setDirtyFunction(this.selectedFeatures);
          }
        }
      } else {
        if (this.funcSingleSelectMode) {
          const graphics = response.results;
          graphics.forEach((graphic) => {
            const att = graphic.graphic.attributes;
            if (att && att.isAsset) {
              fs.push(graphic.graphic);
            }
          });
          let fea;
          if (fs.length > 0) {
            fea = fs[0];
          }
          this.funcSingleSelectMode({fea});
        }
      }
    });
  }
  setSketchColor(sketchColor, graphicColor) {
    this.sketchViewModel.activeFillSymbol.color = sketchColor;
    this.sketchViewModel.activePointSymbol.color = sketchColor;
    this.sketchViewModel.activeLineSymbol.color = sketchColor;
    this.sketchViewModel.updatePolygonSymbol.color = sketchColor;
    this.sketchViewModel.updatePolylineSymbol.color = sketchColor;
    this.sketchViewModel.updatePointSymbol.color = sketchColor;
    this.sketchViewModel.activeVertexSymbol.color = sketchColor;

    this.sketchViewModel.pointSymbol.color = graphicColor;
    this.sketchViewModel.pointSymbol.outline.color = graphicColor;

    this.sketchViewModel.polylineSymbol.color = graphicColor;
    this.sketchViewModel.polylineSymbol.outline.color = graphicColor;

    this.sketchViewModel.polygonSymbol.color = graphicColor;
    this.sketchViewModel.polygonSymbol.outline.color = graphicColor;
  }
  // use for sc-boundary
  drawActionClickMap(event) {

    this.mapView.hitTest(event).then((response) => {
      const graphics = response.results;
      if (graphics && graphics.length > 0) {
        let isDelete = false;
        for (let i = 0; i < graphics.length; i++) {
          const g = graphics[i];
          if (!this.editGraphic && g && g.graphic && g.graphic.layer.id === 'tempGraphics' && this.actionType === 'select') {
            this.editGraphic = g.graphic;
            this.sketchViewModel.layer.add(this.editGraphic);
            const finalColor = this.editGraphic.attributes.finalColor;
            const tempColor = this.editGraphic.attributes.tempColor;
            this.sketchViewModel.complete();
            this.sketchViewModel.update([this.editGraphic], {
              tool: 'reshape',
              toggleToolOnClick: true,
            });
            this.setSketchColor(tempColor, finalColor);
            break;
          }
          if (g.graphic.layer.id !== 'tempGraphics') {
            this.sketchViewModel.complete();
          }
          if (this.actionType === 'delete') {
            if (g && g.graphic && g.graphic.attributes) {
              const idx = g.graphic.attributes.idx;
              if (g.graphic.attributes.realType === 'single') {
                for (let i1 = 0; i1 < this.drawingShapeSingle.length; i1++) {
                  const item = this.drawingShapeSingle[i1];
                  if (item.attributes && item.attributes.idx === idx) {
                    this.drawingShapeSingle.splice(i1, 1);
                    break;
                  }
                }
              } else {
                if (g.graphic.geometry.type === 'point') {
                    for (let i2 = 0; i2 < this.drawingShapeMulti.point.length; i2++) {
                      const item = this.drawingShapeMulti.point[i2];
                      if (item.attributes && item.attributes.idx === idx) {
                        this.drawingShapeMulti.point.splice(i2, 1);
                        break;
                      }
                    }
                } else if (g.graphic.geometry.type === 'polyline') {
                  for (let i3 = 0; i3 < this.drawingShapeMulti.line.length; i3++) {
                    const item = this.drawingShapeMulti.line[i3];
                    if (item.attributes && item.attributes.idx === idx) {
                      this.drawingShapeMulti.line.splice(i3, 1);
                      break;
                    }
                  }
                } else if (g.graphic.geometry.type === 'polygon') {
                  for (let i4 = 0; i4 < this.drawingShapeMulti.polygon.length; i4++) {
                    const item = this.drawingShapeMulti.polygon[i4];
                    if (item.attributes && item.attributes.idx === idx) {
                      this.drawingShapeMulti.polygon.splice(i4, 1);
                      break;
                    }
                  }
                }
              }

              this.sketchViewModel.layer.remove(g.graphic);
              isDelete = true;
            } else {
              console.log('error, this graphic is invalid');
            }
          }
        }

        if (isDelete && this.setDirtyFunction && typeof this.setDirtyFunction === 'function') {
          this.setDirtyFunction();
        }
      }

    });
  }

  addInteraction() {
    // TO DO
  }

  btnAddEvent(btn) {
    // TO DO
  }

  deselectAllControlBtn(currentBtnId) {
    if (this.sketchViewModel) {
      this.sketchViewModel.cancel();
    }
    for (let i = 0; i < this.controlBtns.length; i++) {
      if (this.controlBtns[i].id === currentBtnId) { continue; }
      this.controlBtns[i].style.backgroundColor = 'white';
    }
  }

  modeAction(e) {
    if (this.drawingMode === 'single') {
      if (e && e.currentTarget && e.currentTarget.title ) {
        e.currentTarget.title = 'Multi mode';
      }
      this.drawingMode = 'multi';
      this.modeLabel.innerHTML = 'layers';
      this.tempColor = 'green';
      this.finalColor = this.multiColor;
    } else {
      if (e && e.currentTarget && e.currentTarget.title ) {
        e.currentTarget.title = 'Single mode';
      }
      this.drawingMode = 'single';
      this.modeLabel.innerHTML = 'layers_clear';
      this.tempColor = 'blue';
      this.finalColor = this.color;
    }
    this.actionType = 'mode';
    this.setSketchColor(this.tempColor, this.finalColor);

    this.deselectAllControlBtn(e.currentTarget.id);
  }

  selectAction(e) {
    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'select';
    }
  }

  pointAction(e) {
    this.deselectAllControlBtn(e.currentTarget.id);
    this.drawBtn = e.currentTarget;
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
      this.sketchViewModel.cancel();
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'drawPoint';
      this.sketchViewModel.create('point');
    }
  }

  polygonAction(e) {
    this.drawBtn = e.currentTarget;

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
      this.sketchViewModel.cancel();
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'drawPolygon';
      this.sketchViewModel.create('polygon');
    }
  }

  lineAction(e) {
    this.drawBtn = e.currentTarget;

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
      this.sketchViewModel.cancel();
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'drawLine';
      this.sketchViewModel.create('polyline');
    }
  }

  deleteAction(e) {
    this.deselectAllControlBtn(e.currentTarget.id);

    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
    } else {
      this.actionType = 'delete';
      e.currentTarget.style.backgroundColor = 'grey';
    }

    if (this.setDirtyFunction) {
      this.setDirtyFunction();
    }
  }


  locationAction(e) {
    this.deselectAllControlBtn(e.currentTarget.id);

    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
    } else {
      this.actionType = 'location';
      e.currentTarget.style.backgroundColor = 'grey';
    }
  }

  getLocation() {
    // NOTE : no need here, will move to component ifself
    // if(scope.disabled) return;
    // scope.isVisible = "true";
    // if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(scope.showPosition);
    // } else {
    //     scope.error = "Geolocation is not supported by this browser.";
    // }
  }
  // clone from sclMapViews.addRadioButton and have modify
  addRadioButton(document, element, layers, compId) {
    // TO DO
  }

  addMapViewControl(element, mapViewLayers, compId, layerIds) {
    // TO DO
  }

  // call this function for draw on map

  addControlDraw(compId, pOptions, cb) {
    const layerIds = [];
    const element = document.createElement('div'); // div wrapper

    // TO DO
    // if(pOptions != null){
    //     self.addMapViewControl(element, pOptions.mapViewLayers, compId, layerIds);
    // }

    // add button mode
    let btnId = compId + 'Mode';
    this.modeLabel = document.createElement('i');
    this.modeLabel.setAttribute('class', 'material-icons');
    this.modeLabel.innerHTML = (this.drawingMode === 'single' ? 'layers_clear' : 'layers') ;

    const modeBtn = sclMapViews.createUIButton(document, this.modeAction.bind(this), 'ol-has-tooltip',
      (this.drawingMode === 'single' ? 'Single mode' : 'Multi mode'), null );

    modeBtn.appendChild(this.modeLabel);
    modeBtn.id = btnId;
    layerIds.push(modeBtn.id);

    // add button select
    btnId = compId + 'Select';
    const selectBtn = sclMapViews.createUIButton(document, this.selectAction.bind(this), 'ol-has-tooltip', 'Select', null);
    let iSpan = document.createElement('i');
    iSpan.setAttribute('class', 'material-icons');
    iSpan.innerHTML = 'create';
    selectBtn.appendChild(iSpan);
    selectBtn.id = btnId;
    layerIds.push(selectBtn.id);

    // add button point
    btnId = compId + 'Point';
    const pointBtn = sclMapViews.createUIButton(document, this.pointAction.bind(this), 'ol-has-tooltip', 'Point', null);
    iSpan = document.createElement('i');
    iSpan.setAttribute('class', 'material-icons');
    iSpan.innerHTML = 'pin_drop';
    pointBtn.appendChild(iSpan);
    pointBtn.id = btnId;
    layerIds.push(pointBtn.id);

    // add button line
    btnId = compId + 'Line';
    const lineBtn = sclMapViews.createUIButton(document, this.lineAction.bind(this), 'ol-has-tooltip', 'Line', null);
    iSpan = document.createElement('i');
    iSpan.setAttribute('class', 'material-icons');
    iSpan.innerHTML = 'linear_scale';
    lineBtn.appendChild(iSpan);
    lineBtn.id = btnId;
    layerIds.push(lineBtn.id);

    // add button polygon
    btnId = compId + 'Polygon';
    const polygonBtn = sclMapViews.createUIButton(document, this.polygonAction.bind(this), 'ol-has-tooltip', 'Polygon', null);
    iSpan = document.createElement('i');
    iSpan.setAttribute('class', 'material-icons');
    iSpan.innerHTML = 'turned_in_not';
    polygonBtn.appendChild(iSpan);
    polygonBtn.id = btnId;
    layerIds.push(polygonBtn.id);


    // add button location
    btnId = compId + 'CurrentLocation';
    const locationBtn = sclMapViews.createUIButton(document, this.locationAction.bind(this), 'ol-has-tooltip', 'Current Location', null);
    iSpan = document.createElement('i');
    iSpan.setAttribute('class', 'material-icons');
    iSpan.innerHTML = 'my_location';
    locationBtn.appendChild(iSpan);
    locationBtn.id = btnId;
    layerIds.push(locationBtn.id);

    // add button delete
    btnId = compId + 'Delete';
    const deleteBtn = sclMapViews.createUIButton(document, this.deleteAction.bind(this), 'ol-has-tooltip', 'Delete', null);
    iSpan = document.createElement('i');
    iSpan.setAttribute('class', 'material-icons');
    iSpan.innerHTML = 'delete';
    deleteBtn.appendChild(iSpan);
    deleteBtn.id = btnId;
    layerIds.push(deleteBtn.id);


    const elementCtrl = document.createElement('div');
    elementCtrl.className = 'select-action ol-control custom-control';

    elementCtrl.appendChild(modeBtn);
    elementCtrl.appendChild(selectBtn);
    elementCtrl.appendChild(pointBtn);
    elementCtrl.appendChild(lineBtn);
    elementCtrl.appendChild(polygonBtn);
    elementCtrl.appendChild(locationBtn);
    elementCtrl.appendChild(deleteBtn);


    this.elementCtrl = elementCtrl;

    this.controlBtns = [modeBtn, selectBtn, pointBtn, lineBtn, polygonBtn, locationBtn, deleteBtn];
    this.btnAddEvent(modeBtn); this.btnAddEvent(selectBtn); this.btnAddEvent(pointBtn);
    this.btnAddEvent(lineBtn); this.btnAddEvent(polygonBtn); this.btnAddEvent(locationBtn);
    this.btnAddEvent(deleteBtn);

    element.appendChild(elementCtrl);

    this.ActionControls.push(element);

    if (cb && typeof cb === 'function') {
      cb(layerIds);
    }
  }

  // test redraw layers

  testRedraw(e) {
    // TO DO

  }
  addTestBtn(element) {
    // TO DO
  }

  addControl(ActionControl, element, options) {
    this.ActionControls.push(element);
  }

  setupControl(ActionControl) {
    // TO DO
  }

  mapClickEvent(cb) {
    this.mapView.on('click', (evt) => {
      if (this.type === 0) { // sc-boundary
        this.drawActionClickMap(evt);
      } else if (this.type === 1) { // sc-address-map
        this.setLayerSelectAsset(evt);
      } else {
        evt.latLng = { lat: evt.mapPoint.latitude, lng: evt.mapPoint.longitude };
        if (cb && typeof cb === 'function') {
          cb(evt);
        }
      }

    });
  }

  mapPointerMoveEvent(cb) {
    this.mapView.on('pointer-move', (event) => {
      this.mapView.hitTest(event).then((response) => {
        const lst = response.results.filter((result) => {
          return ( result.graphic.attributes && result.graphic.attributes.isAsset);
        });
        if (this.mouseHoverFeature) {
          this.layerAssets[this.mouseHoverFeature.attributes.zIndex].graphicLayer.graphics.remove(this.mouseHoverFeature);
          this.mouseHoverFeature = null; // reset
        }
        if (lst && lst.length > 0) {
          try {
            this.mouseHoverFeature = lst[0].graphic.clone();
          } catch (err) {
            console.log('err = ' + err);
          }
        }
        if (this.mouseHoverFeature) {
          if (this.type === 3) { // selected-asset
            let color = '#0099FF'; // default ol blue
            if (this.compActionType === 'primary') {
                color = 'limegreen';
            } else if (this.compActionType === 'secondary') {
                color = 'black';
            } else {
              if (this.toolTipOnFeatureHover && (typeof this.toolTipOnFeatureHover === 'function')) {
                this.toolTipOnFeatureHover(this.mouseHoverFeature);
              }
            }
            if (this.mouseHoverFeature.attributes.type !== 'Point') {
              if (this.mouseHoverFeature.attributes.type === 'LineString'
               || this.mouseHoverFeature.attributes.type === 'MultiLineString'
               || this.mouseHoverFeature.attributes.type === 'Polyline') {
                this.mouseHoverFeature.symbol.color = color;
              } else {
                this.mouseHoverFeature.symbol.outline.color = color;
                this.mouseHoverFeature.symbol.color = 'white';
                this.mouseHoverFeature.symbol.color.a = 0.5;
              }
              this.layerAssets[this.mouseHoverFeature.attributes.zIndex].graphicLayer.graphics.add(this.mouseHoverFeature);
            }
          }
          if (cb && typeof cb === 'function') {
            cb({fea: this.mouseHoverFeature, pixel: [ event.x, event.y ] });
          }
        }
      });
    });
  }

  getPointFeature(location , image, name, id, relatedAsset, color, layerDisplayOnly, tooltip, anchor, type, layerName) {
    // TO DO
  }

  updateLocation(lat, lon, id, image, name, proId, isMapClick) {
    if (!isMapClick) {
      this.mapView.center = [lon, lat];
    }
    if (this.marker) {
      this.removeFeature(this.marker, this.layerIndexAddress);
    }

    if (!image) { image = sclMapConstant.MAP_MARKER; }
    if (image && image.charAt(0) !== '/') { image = '/' + image; }
    this.marker = this.createPoint(lon, lat, { id: proId, image, name });

    // this.source.addFeature(this.marker);//13835
    this.addFeature(this.marker, this.layerIndexAddress);

  }
  removeLocation(feature) {
    if (feature && this.layerAssets[this.layerIndexAddress] && this.layerAssets[this.layerIndexAddress].graphicLayer) {
      this.layerAssets[this.layerIndexAddress].graphicLayer.graphics.remove(feature);
    }
    this.marker = null;
  }

  zoomToLocation(lat, lon) {
    this.mapView.goTo({
      center: [lon, lat],
      zoom: 20
    });
  }
  zoomToValue(zoomValue) {
    // if (!zoomValue && this.defaultZoom ) { zoomValue = this.defaultZoom; } // 14707
    if (zoomValue) {
      this.mapView.goTo({
        zoom: zoomValue
      });
    }
  }
  // 14781
  centerDefault() {
    this.mapView.goTo({
        center: [this.defaultLon, this.defaultLat],
        zoom: 18
    });
  }
  // 14781
  fitLayersOLD(layersIndexFit, hasDefaultCoord) {
    let fullExtent = null;
    let count = 0;
    if (hasDefaultCoord) {
        const geometry = {
            type: 'point',
            longitude: this.defaultLon,
            latitude: this.defaultLat
        };
        const extent = this.createExtentForPoint(geometry);
        fullExtent = extent.clone();
        count++;
    }
    for (let i = 0; i < layersIndexFit.length; i++) {
      const idx = layersIndexFit[i];
      if (this.isHeatLayer(idx)) {
        continue; // heat map
      }
      const layer = this.layerAssets[idx].graphicLayer;
      const graphics = layer.graphics;
      for (let j = 0; j < graphics.length; j++) {
        const f = graphics.getItemAt(j);
        if (!f || !f.attributes || !f.attributes.isAsset || !f.geometry) {
            continue;
        }
        let extent = f.geometry.extent;
        if (f.geometry.type === 'point') {
          extent = this.createExtentForPoint(f.geometry);
        }
        if (extent) {
          count++;
          if (!fullExtent) {
            fullExtent = extent.clone();
          } else {
            fullExtent.union(extent);
          }
        }
      }
    }
    if (fullExtent) {
        if (count === 1) { // esri can not extent 1 coordinate
            this.mapView.goTo({
                center: [fullExtent.xmin, fullExtent.ymin],
                zoom: 20
            });
        } else {
          this.mapView.goTo(fullExtent).then(function() {
          });
        }
    }
  }
  fitLayers(layersIndexFit, hasDefaultCoord) {
    let fullExtent = null;
    let count = 0;
    if (hasDefaultCoord) {
        const geometry = {
            type: 'point',
            longitude: this.defaultLon,
            latitude: this.defaultLat
        };
        const extent = this.createExtentForPoint(geometry);
        fullExtent = extent.clone();
        count++;
    }
    for (let i = 0; i < layersIndexFit.length; i++) {
      const idx = layersIndexFit[i];
      if (this.isHeatLayer(idx)) {
        continue; // heat map
      }
      const layer = this.layerAssets[idx].graphicLayer;
      const graphics = layer.graphics;
      if (graphics.length === 0) { continue; }
      const f0 = graphics.getItemAt(0);
      if (graphics.length === 1 && f0.geometry.type === 'point') {  // esri can not extent 1 coordinate
        const extent = this.createExtentForPoint(f0.geometry);
        this.mapView.goTo({
          center: [extent.xmin, extent.ymin],
          zoom: 20
        });
      } else {
        const e = graphics
        .map(g => g.geometry)
        .reduce(
          (acc, geom) => (
            {
              xmin: Math.min(acc.xmin, geom.longitude),
              ymin: Math.min(acc.ymin, geom.latitude),
              xmax: Math.max(acc.xmax, geom.longitude),
              ymax: Math.max(acc.ymax, geom.latitude)
            }
          ),
          {
            xmin: Number.MAX_SAFE_INTEGER,
            ymin: Number.MAX_SAFE_INTEGER,
            xmax: Number.MIN_SAFE_INTEGER,
            ymax: Number.MIN_SAFE_INTEGER
          }
        );
        const extent = new this.lib.Extent(e);
        if (extent) {
          count++;
          this.mapView.extent = extent.expand(2);
        }
      }
    }
  }

  createMarkerAsset(lat, lon, id, image, name , type) {
    let f = this.getFeatureById(id);
    if (!f) {
      f = this.createPoint(lon, lat, {image, name, type: 'Point'});
    }

    if (type) { f.attributes.assetType = type; }
    f.attributes.id = id;

    if (type === sclMapConstant.ASSET_PRIMARY_TYPE) {
      this.addFeature(f, this.layerIndexPrimary);
    } else if (type === sclMapConstant.ASSET_SECONDARY_TYPE) {
      this.addFeature(f, this.layerIndexSecondary);
    } else {
      this.addFeature(f, this.layerIndexAddress);
    }

    return [lon, lat];
  }

  getGEOJSON(cb) {
    const geoJson = { type: 'FeatureCollection', features: [] };
    if (this.drawingShapeSingle) {// single shape
      for (let i1 = 0; i1 < this.drawingShapeSingle.length; i1++) {
        const g = this.drawingShapeSingle[i1]; // graphic
        const geomType = g.geometry.type;
        if (geomType === 'point') {
            geoJson.features.push({
                type: 'Feature',
                properties: null,
                geometry: {
                    type: 'Point',
                    coordinates: [ g.geometry.longitude, g.geometry.latitude ]
                }
            });
        } else if (geomType === 'polyline') {
          const coors1 = [];
          const path0 = g.geometry.paths[0];
          for (let j1 = 0; j1 < path0.length; j1++) {
            const xy1 = path0[j1];
            const lngLat1 = this.lib.webMercatorUtils.xyToLngLat(xy1[0], xy1[1]);
            coors1.push(lngLat1);
          }
          geoJson.features.push({
            type: 'Feature',
            properties: null,
            geometry: {
                type: 'LineString',
                coordinates: coors1
            }
          });
        } else if (geomType === 'polygon') {
          const ring0 = g.geometry.rings[0];
          const coors2 = [[]];
          for (let j2 = 0; j2 < ring0.length; j2++) {
            const xy2 = ring0[j2];
            const lngLat = this.lib.webMercatorUtils.xyToLngLat(xy2[0], xy2[1]);
            coors2[0].push(lngLat);
          }
          geoJson.features.push({
            type: 'Feature',
            properties: null,
            geometry: {
                type: 'Polygon',
                coordinates: coors2
            }
          });
        }
      }
    }

    if (this.drawingShapeMulti) { // multi shape
        if (this.drawingShapeMulti.point && this.drawingShapeMulti.point.length > 0) {
          const coors3 = [];
          for (let i1 = 0; i1 < this.drawingShapeMulti.point.length; i1++) {
            const g = this.drawingShapeMulti.point[i1]; // graphic
            coors3.push([ g.geometry.longitude, g.geometry.latitude ]);
          }
          geoJson.features.push({
            type: 'Feature',
            properties: null,
            geometry: {
                type: 'MultiPoint',
                coordinates: coors3
            }
          });
        }
        if (this.drawingShapeMulti.line && this.drawingShapeMulti.line.length > 0) {
            const coors4 = [];
            for (let i = 0; i < this.drawingShapeMulti.line.length; i++) {
                const g = this.drawingShapeMulti.line[i];
                const lst = [];
                for (let j = 0; j < g.geometry.paths.length; j++) {
                    const j0 = g.geometry.paths[j];
                    for (let k = 0; k < j0.length; k++) {
                      const xy = j0[k];
                      const lngLat = this.lib.webMercatorUtils.xyToLngLat(xy[0], xy[1]);
                      lst.push(lngLat);
                    }
                }
                coors4.push(lst);
            }
            geoJson.features.push({
              type: 'Feature',
              properties: null,
              geometry:{
                  type: 'MultiLineString',
                  coordinates: coors4
              }
            });
        }
        if (this.drawingShapeMulti.polygon && this.drawingShapeMulti.polygon.length > 0) {
            const coors = [];
            for (let i = 0; i < this.drawingShapeMulti.polygon.length; i++) {
              const g = this.drawingShapeMulti.polygon[i];
              const lst = [];
              for (let j = 0; j < g.geometry.rings.length; j++) {
                const lst0 = [];
                const j0 = g.geometry.rings[j];
                for (let k = 0; k < j0.length; k++) {
                  const xy = j0[k];
                  const lngLat = this.lib.webMercatorUtils.xyToLngLat(xy[0], xy[1]);
                  lst0.push(lngLat);
                }
                lst.push(lst0);
              }
              coors.push(lst);
            }
            geoJson.features.push({
              type: 'Feature',
              properties: null,
              geometry: {
                  type: 'MultiPolygon',
                  coordinates: coors
              }
            });
        }
    }

    if (cb && typeof cb === 'function') {
      cb(geoJson);
    }
  }

  transformEPSG(long, lat, from, to) {
    // TO DO
  }


  checkMapEmpty(pCanvas) {
    // TO DO

  }

  isHeatLayer(layerIndex) {
    if (layerIndex < this.layerAssets.length) {
      const isHeatMap = this.layerAssets[layerIndex].isHeatMap;
      if (isHeatMap) { return true; }
      return false;
    }
    return false;
  }

  setMinMax(minMax, lng, lat) {
    if (!lat || !lng) {
      return minMax;
    }
    if (lat < minMax.minLat) {
      minMax.minLat = lat;
    } else if (lat > minMax.maxLat) {
      minMax.maxLat = lat;
    }
    if (lng < minMax.minLng) {
      minMax.minLng = lng;
    } else if (lng > minMax.maxLng) {
      minMax.maxLng = lng;
    }
    return minMax;
  }

  // arcGIS unsupport extent for a point
  createExtentForPoint(geom) {
    // let xy = webMercatorUtils.lngLatToXY(geom.longitude, geom.latitude);
    // let ext = new Extent({
    //     xmin: xy[0],
    //     ymin: xy[1],
    //     xmax: xy[0],
    //     ymax: xy[1],
    //     spatialReference: this.mapView.spatialReference
    // });
    // return ext;
    const ext = new this.lib.Extent({
      xmin: geom.longitude,
      ymin: geom.latitude,
      xmax: geom.longitude,
      ymax: geom.latitude,
      spatialReference: 4326
    });
    return ext;
  }

  fit(ConfigService, maxZoom, initialZoomChange, isCheckEmpty) {
    // zoom to show all the features
    this.initialZoomChange = initialZoomChange;

    this.fitCoors = [];
    let fullExtent = null;
    let countAdd = 0;
    for (let i = 1; i < this.layerAssets.length; i++) {
      if (this.isHeatLayer(i)) {
        continue; // heat map
      }
      const layer = this.layerAssets[i].graphicLayer;
      const graphics = layer.graphics;
      for (let j = 0; j < graphics.length; j++) {
        const f = graphics.getItemAt(j);
        if (!f || !f.attributes || !f.attributes.isAsset || !f.geometry) {
          continue;
        }
        let extent = f.geometry.extent;
        if (f.geometry.type === 'point') {
          extent = this.createExtentForPoint(f.geometry);
        }
        if (extent) {
          if (!fullExtent) {
            fullExtent = extent.clone();
          } else {
            fullExtent.union(extent);
          }
          countAdd++;
        }
      }
    }

    if (fullExtent) {
      console.log('%c arcGIS FIT, this.fitCoors = ' + this.fitCoors + ', mapLoaded = ' + this.mapLoaded, 'color:blue');
      this.fitCoors.push([fullExtent.xmin, fullExtent.ymin]);
      this.fitCoors.push([fullExtent.xmax, fullExtent.ymax]);
      this.mapView.goTo(fullExtent).then(function() {

      });
    }
  }

  fitCoords(coords) {
    // calculate bounds base on collection of coordinates
    if (!coords || coords.length === 0) { return; }
    this.fitCoors = coords;
  }

  fitCoordsAction() {
    this.fitCoordCount = this.fitCoors.length;
    console.log('arcGIS fit action , type = ' + this.type + ', fitCoordCount = ' + this.fitCoordCount );
    if (this.fitCoordCount < 2) { // esri can not extent 1 coordinate
      if (this.fitCoordCount === 1) {
          this.mapView.goTo({
              center: this.fitCoors[0],
              zoom: this.zoomFloor
          });
      }
      this.fitCoors = null;
      return;
    }
    let xMin = this.fitCoors[0][0];
    let yMin = this.fitCoors[0][1];
    let xMax = this.fitCoors[0][0];
    let yMax = this.fitCoors[0][1];
    for (let i = 0; i < this.fitCoors.length; i++) {
        const x = this.fitCoors[i][0];
        const y = this.fitCoors[i][1];
        if ( x > xMax) {
          xMax = x;
        }
        if ( x < xMin) {
          xMin = x;
        }
        if ( y > yMax) {
          yMax = y;
        }
        if ( y < yMin) {
          yMin = y;
        }
    }
    const leftTop = this.lib.webMercatorUtils.lngLatToXY(xMin, yMin);
    const rightBottom = this.lib.webMercatorUtils.lngLatToXY(xMax, yMax);

    const ext = new this.lib.Extent({
        xmin: leftTop[0],
        ymin: leftTop[1],
        xmax: rightBottom[0],
        ymax: rightBottom[1],
        spatialReference: this.mapView.spatialReference
    });
    this.mapView.extent = ext;

    let currentZoom = this.mapView.zoom;
    if (this.type === 3) { // sc-selected-asset
      if (this.fitCoordCount === 1) {
        currentZoom = currentZoom - 2;
        if (currentZoom < 0) {
          currentZoom = 1;
        }
        this.mapView.zoom = currentZoom;
      }
    } else if (this.type === 1) { // sc-address-map
      if (this.initialZoomChange && this.initialZoomChange !== 0) {
        currentZoom += this.initialZoomChange;
        this.mapView.zoom = currentZoom;
      }
    }
    if (this.mapView.zoom < 0) {
      this.mapView.zoom = 1;
    }
    console.log('%c fitCoord, mapZoom = ' + this.mapView.zoom, 'color:blue');
    this.clampZoomFloor();

    this.fitCoors = null;
    this.fitCoordCount = 0;
  }


  mapReadOnly(isReadOnly) {
    // TO DO
  }

  getAllFeatures() {
    const features = [];
    for (let i = 1; i < this.layerAssets.length; i++) {
      if (this.isHeatLayer(i)) { continue; }// heat map
      this.layerAssets[i].graphicLayer.graphics.forEach((feature) => {
        if (feature.attributes && feature.attributes.isAsset) {
          features.push(feature);
        }
      });
    }
    return features;
  }
  getFeaturesFromMap(features, pixel, type, assetSelectionsAvailable) {
    let existedFeature;
    for (let i = features.length - 1; i > -1; i--) {
      if (!features[i] || !features[i].attributes) { continue; }
      const zIndex = features[i].attributes.zIndex;

      if ( features[i].attributes.id.indexOf(type) > -1) {
        existedFeature = features[i];
        features.splice(i, 1);
        continue;
      }
      if ( (type === 'primary' && features[i].attributes.id.indexOf('secondary') > -1)
        || (type === 'secondary' && features[i].attributes.id.indexOf('primary') > -1) ) {
        features.splice(i, 1);
        continue;
      }

      if (assetSelectionsAvailable) {
        const iAssetSelectionsAvailable = assetSelectionsAvailable[((zIndex - 1) < 0 ? 0 : (zIndex - 1))];
        if ( iAssetSelectionsAvailable != null && iAssetSelectionsAvailable.indexOf(type) < 0 ) {
          let sType = type;
          if (type != null && type.trim().length > 0) { sType = type.charAt(0).toUpperCase() +
            ( (type != null && sType.trim().length > 1 ) ? type.slice(1) : '' ); }
          console.log('sc-selected-asset: The assetSelectiosAvailable field is not set to allow ' + sType + ' selections for this layer');
          features.splice(i, 1); // remove this feature
        }
      }

    }
    return existedFeature;
  }
  getAssetProperties(feature, relatedFields, coordinates, typeAsset, typeSelection) {
    let name = '';
    let id = '';
    if (feature.attributes) {
      name = feature.attributes.name;
      id = feature.attributes.id;
    }


    const propertiesLinkAsset = {
      documentId: id,
      name
    };
    const asset: any = {
      type: 'Feature',
      properties : {
        type: typeAsset,
        linkAssets: []
      }
    };
    if (!typeSelection || typeSelection === 'featureCollection') {
      asset.geometry = {
        type : 'Point',
        coordinates
      };
    } else if (typeSelection !== 'undefined' && typeSelection === 'Asset') {
      const t = feature.attributes.type;
      asset.geometry = {
        type : t,
        coordinates
      };

    }

    if (!id) {
      return '';
    }
    if (relatedFields) {
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const value = feature.attributes[field];
          if (value) {
            propertiesLinkAsset[field] = value;
          }
        }
      }
    }
    asset.properties.linkAssets.push(propertiesLinkAsset);
    return asset;
  }

  removeUnselectedAssetItem(existAsset, assets, type) {
    if (existAsset) {
      let isExist = false;
      let idExistAsset = existAsset.properties.linkAssets[0].documentId;
      if (idExistAsset && idExistAsset.indexOf('_') > -1) { idExistAsset = idExistAsset.split('_')[0]; }
      for (let j = 0; j < assets.length; j++) {
        const item = assets[j];
        let idItem = item.properties.linkAssets[0].documentId;
        if (!idItem) { continue; }
        if (idItem.indexOf('_') > -1) { idItem = idItem.split('_')[0]; }
        if (idItem === idExistAsset) {
          assets.splice(j, 1);
          isExist = true;
        }
      }
      const len = this.selectedAssets.length;
      for (let i = len - 1; i > -1; i--) {
        let iId = this.getFeatureId(this.selectedAssets[i]);
        if (iId && iId.indexOf('_') > -1) { iId = iId.split('_')[0]; }
        if (iId === idExistAsset) {
          const f = this.selectedAssets[i];
          if (!f || !this.getFeatureId(f) ) { continue; }
          if (type === 'primary' && f.attributes.assetType.indexOf(type) > -1 ) {
            this.removeFeature(f, this.layerIndexPrimary);
            this.selectedAssets.splice(i, 1);
            isExist = true;
          } else if (type === 'secondary' && f.attributes.assetType.indexOf(type) > -1 ) {
            this.removeFeature(f, this.layerIndexSecondary);
            this.selectedAssets.splice(i, 1);
            isExist = true;
          }
        }
      }
      return isExist;
    }
    return false;
  }

  parseAssetsFromFeatures(features, assetField, coor, typeAsset, mode) {
    if (mode === 'Asset') {
      return this.getAssetProperties(features, assetField.relatedFields, coor, typeAsset, mode);
    } else {
      const assets = [];
      for (let i = 0; i < features.length; i++) {
        const asset = this.getAssetProperties(features[i], assetField.relatedFields, coor[i], typeAsset, null);
        if (!asset) {return; }
        assets.push(asset);
      }
      return assets;
    }
  }

  getAllFeaturesSelected() {
    // TO DO
  }
  addInteractionSelect(currentSelected) {
    if (this.selectedFeatures == null || ( currentSelected != null && this.selectedFeatures.length !== currentSelected.length) ) {
      this.selectedFeatures = currentSelected;
    }

    // TO DO : override style or remove graphics ?
    // let self = this;
    // this.layerAssets[this.layerIndexUser].forEach(function(f){
    //     self.layerAssets[self.layerIndexUser].overrideStyle(f, {zIndex: self.layerIndexUser, visible: true});
    // });

    // for(let i = 0; i < this.selectedFeatures.length; i++){
    //     let id = this.getFeatureId(this.selectedFeatures[i]);//this.selectedFeatures[i].j.id;
    //     if(id && id.indexOf("_") > -1) id = id.split("_")[0];
    //     for(let j = 0; j < this.layerIndexFilter + 1; j++){
    //         if(this.isHeatLayer(j)) continue;//heat map
    //         this.layerAssets[j].forEach(function(f){
    //             let fId = self.getFeatureId(f);
    //             if(fId && fId.indexOf(id) > -1){//if(f.j.id.indexOf(id) > -1){
    //                 self.layerAssets[j].overrideStyle(f, {zIndex: j});
    //             }
    //         });
    //     }
    // }
    this.multipleSelection = true;
  }
  removeInteractionSelect() {
    this.multipleSelection = false;
    // TO DO : override style or remove graphics ?
    // let self = this;
    // this.layerAssets[this.layerIndexUser].forEach(function(f){
    //     self.layerAssets[self.layerIndexUser].overrideStyle(f, {visible: false});
    // });

    // for(let i = 0; i < this.selectedFeatures.length; i++){
    //     let id = this.getFeatureId(this.selectedFeatures[i]);//this.selectedFeatures[i].j.id;
    //     if(id && id.indexOf("_") > -1) id = id.split("_")[0];
    //     for(let j = 0; j < this.layerIndexFilter + 1; j++){
    //         if(this.isHeatLayer(j)) continue;//heat map
    //         this.layerAssets[j].forEach(function(f){
    //             let fId = self.getFeatureId(f);
    //             if(fId && fId.indexOf(id) > -1){// if(f.j.id.indexOf(id) > -1){
    //                 self.layerAssets[j].overrideStyle(f, {zIndex: j});
    //             }
    //         });
    //     }
    // }
  }
  showLayer(options) {
    if (options.isShow) {
      this.layerAssets[options.layerIndex].graphicLayer.visible = true;
      this.addInteractionSelect(options.currentSelected);
    } else {
      this.layerAssets[options.layerIndex].graphicLayer.visible = false;
      this.removeInteractionSelect();
    }
  }
  activeInteractionSelect(isActive) {
    this.multipleSelection = isActive;
  }

  drawActionDelete(evt) {
    // TO DO
  }

  drawActionProperties(evt) {
    // TO DO
  }
  traverseCoor(coor, obj) {
    if (Array.isArray(coor)) {
      for (let i = 0; i < coor.length; i++) {
        if (Array.isArray(coor[i])) {
          this.traverseCoor(coor[i], obj);
        } else {
          if (isNaN(coor[i]) ) { obj.hasNaN = true; } else { coor[i] = Number(coor[i]); }
        }
      }
    }
  }
  createLabel(lat, lng, label, id, color) {
    const font = new this.lib.Font();
    font.size =  (!label.labelFontSize) ? '12px' : ( (typeof label.labelFontSize === 'string') ?
      (label.labelFontSize.replace('px', '') + 'px' ) : (label.labelFontSize + 'px') );
    if (label.labelFontWeight) {
      const weight = label.labelFontWeight.toLowerCase();
      if (weight === 'italic') {
        font.style = weight;
      } else {
        font.weight = weight;
      }
    }
    font.family = (label.labelFont) ? label.labelFont : 'Arial';

    const currentZoom = this.mapView.zoom;
    const displayZoom = (label.labelDisplayZoom === '' || label.labelDisplayZoom == null) ? 9 :
      (label.labelDisplayZoom > 17 ? 17 : label.labelDisplayZoom);
    const text = (currentZoom < displayZoom ? undefined : ((label.labelText === '' || label.labelText == null) ?
      undefined : label.labelText) );

    const textSymbol = new this.lib.TextSymbol(text);
    textSymbol.color = (label.labelColor ? label.labelColor : color).toLowerCase();
    textSymbol.haloColor = (label.labelOutlineColor) ? label.labelOutlineColor.toLowerCase() : 'black';
    textSymbol.haloSize = (!label.labelOutlineWidth) ? '0px' : ( (typeof label.labelOutlineWidth === 'string') ?
      (label.labelOutlineWidth.replace('px', '') + 'px' ) : (label.labelOutlineWidth + 'px') );
    textSymbol.angle = (label.labelRotation) ? label.labelRotation : 0;
    if (this.textSymbolVerticalAlignment.indexOf(label.labelTextBaseline) > -1 ) {
      textSymbol.verticalAlignment = label.labelTextBaseline;
    } else {
      textSymbol.verticalAlignment = 'baseline';
    }
    if (this.textSymbolHorizontalAlignment.indexOf(label.labelTextAlign) > -1) {
      textSymbol.horizontalAlignment = label.labelTextAlign;
    } else {
      textSymbol.horizontalAlignment = 'center';
    }
    textSymbol.xoffset = (!label.labelOffsetX) ? '0px' : ( (typeof label.labelOffsetX === 'string') ?
      (label.labelOffsetX.replace('px', '') + 'px' ) : (label.labelOffsetX + 'px') );
    textSymbol.yoffset = (!label.labelOffsetY) ? '0px' : ( (typeof label.labelOffsetY === 'string') ?
      (label.labelOffsetY.replace('px', '') + 'px' ) : (label.labelOffsetY + 'px') );

    textSymbol.font = font;

    const pt = new this.lib.Point( lng, lat);
    const lb = new this.lib.Graphic(pt, textSymbol);
    lb.attributes = {
      id: 'lb_' + id,
      isAsset: false
    };

    return lb;
  }
  updateLabelAllLayers() {
    // just declare
  }

  setupPointSymbol(options) {
    // TO DO : anchor
    let color = 'black'; let width = 1;
    if (options.color) { color = options.color; }
    if (options.width) { width = options.width; }

    color = new this.lib.Color(color.toLowerCase());


    let symbol: any = {
      type: 'simple-marker',
      color ,  // orange
      outline: {
        color, // white
        width
      }
    };
    if (options && options.image) {
      if (options.image.charAt(0) !== '/') { options.image = '/' + options.image; }
      let anchor = [0, 0];
      if (options.anchor) { anchor = options.anchor; }
      const size = 24;
      anchor = this.getAnchor(options.image, anchor);
      let xoffset = 0; let yoffset = 0;
      if (anchor) {
        xoffset = size * anchor[0]; // default width icon of arcGIS = 12px
        yoffset = size * anchor[1]; // default height icon of arcGIS = 12px
      }

      symbol = {
        type: 'picture-marker',
        url: options.image,
        width: size,
        height: size,
        xoffset,
        yoffset
      };
    }
    return symbol;
  }
  // this.coorAnchor = function(coor, offset){
  //     let num = coor;
  //     let sN1 = num.toString().split('.')[0];
  //     let sN2 = num.toString().split('.')[1];
  //     let n2 = parseInt(sN2);
  //     n2 = n2 - offset;

  //     let sNewNum = sN1 + '.' + n2;
  //     let newNum = parseFloat(sNewNum);
  //     return newNum;
  // };
  coorAnchor(coor, offset) {
    const num = coor;
    const sN1 = num.toString().split('.')[0];
    const sN2 = num.toString().split('.')[1];
    let n2 = parseInt(sN2, 10);
    n2 = n2 - offset;

    const s = n2 + '';
    const len = sN2.length - s.length;
    let s2 = '';
    for (let i = 0; i < len; i++) {
      s2 += '0';
    }
    s2 += n2;

    const sNewNum = sN1 + '.' + s2;
    const newNum = parseFloat(sNewNum);
    return newNum;
  }
  createPoint(lng, lat, options) {
    const symbol = this.setupPointSymbol(options);

    // re-calculate lat/lng
    if (options && options.image) {
      // lat = lat - Math.floor(lat) - symbol.yoffset;
      // lng = lng - Math.floor(lng) - symbol.xoffset;
      lat = this.coorAnchor(lat, symbol.yoffset);
      lng = this.coorAnchor(lng, symbol.xoffset);
    }

    const point = new this.lib.Graphic({
      geometry: {
        type: 'point',
        longitude: lng,
        latitude: lat
      },
      symbol,
      attributes: {
        isAsset: true
      }
    });
    this.setFeatureProperties(point, options);

    return point;
  }
  createLine(coords, options) {
    let color = 'black'; let width = 1;
    if (options) {
      if (options.color) { color = options.color; }
      if (options.width) { width = options.width; }
    }

    color = new this.lib.Color(color.toLowerCase());

    let cap = 'square'; let dash = 'solid';
    if (options && options.layer) {
      if (options.layer.lineCap) { cap = options.layer.lineCap; }
      if (options.layer.lineDash) { dash = 'dash'; }
    }

    const line = new this.lib.Graphic({
      geometry: {
        type: 'polyline',
        paths: coords
      },
      symbol: {
        type: 'simple-line',
        color,
        width,
        cap,
        style: dash
      },
      attributes: {
        isAsset: true
      }
    });
    this.setFeatureProperties(line, options);

    return line;
  }
  createPolygon(coords, options) {
    let color = 'black'; let outlineColor = 'black'; let width = 1;
    if (options) {
      if (options.color) { color = options.color; }
      if (options.width) { width = options.width; }
      if (options.fillColor) { outlineColor = options.fillColor; }
    }

    color = new this.lib.Color(color.toLowerCase());
    outlineColor = new this.lib.Color(outlineColor.toLowerCase());

    let cap = 'square'; let dash = 'solid';
    if (options && options.layer) {
      if (options.layer.lineCap) { cap = options.layer.lineCap; }
      if (options.layer.lineDash) { dash = 'dash'; }
    }

    const polygon = new this.lib.Graphic({
      geometry: {
        type: 'polygon',
        rings: coords
      },
      symbol: {
        type: 'simple-fill',
        color,  // orange, opacity 80%
        outline: {
          type: 'simple-line',
          color: outlineColor,
          width,
          cap,
          style: dash
        }
      },
      attributes: {
        isAsset: true
      }
    });
    this.setFeatureProperties(polygon, options);
    return polygon;
  }
  createMultiPoint(coords, options) {
    if (options.image) { delete options.image; }

    const mpJson = {points: coords};
    const geom = new this.lib.Multipoint(mpJson);

    const symbol = this.setupPointSymbol(options);

    const obj = new this.lib.Graphic({
      geometry: geom,
      symbol,
      attributes: {
        isAsset: true
      }
    });

    this.setFeatureProperties(obj, options);
    obj.attributes.coordinatesData = coords;
    obj.attributes.type = 'MultiPoint';
    return obj;
  }

  createMultiLineString(coords, options) {
    const obj = this.createLine(coords[0], options);
    obj.attributes.type = 'MultiLineString';
    obj.attributes.coordinatesData = coords;
    for (let i = 1; i < coords.length; i++) {
      obj.geometry.paths.push(coords[i]);
    }

    return obj;
  }
  createMultiPolygon(coords, options) {
    const obj = this.createPolygon(coords[0], options);
    for (let i = 1; i < coords.length; i++) {
      const p = this.createPolygon(coords[i], options);
      obj.geometry.rings.push(p.geometry.rings[0]);
    }
    obj.attributes.type = 'MultiPolygon';
    obj.attributes.coordinatesData = coords;

    return obj;
  }

  createFeatureByType(coord, type, options) {
    let feature;
    options.type = type;
    if (options.tooltips) {
      const tooltip = options.tooltips;
      options.tooltip = tooltip;
      delete options.tooltips;
    }

    if (type === 'Point') {
      const lng = Number(coord[0]); const lat = Number(coord[1]) ;
      if (isNaN(lng) || isNaN(lat)) { return null; }


      let img = sclMapConstant.MAP_MARKER;
      if (options.point) { img = options.point; }
      if (options.imageFileNo) {
        if (options.imageFileNo === sclMapConstant.MAP_MARKER
          || options.imageFileNo === sclMapConstant.MAP_PRIMARY_ASSET
          || options.imageFileNo === sclMapConstant.MAP_SECONDARY_ASSET) {
          img = options.imageFileNo;
        } else { img = '/api/getFile/' + options.imageFileNo.replace('/api/getFile/', ''); }
      }
      if (options.image) { img = options.image; }
      options.image = img;
      feature = this.createPoint(lng, lat, options);

      if (options.label) {
        feature.attributes.lb = this.createLabel(lat, lng, options.label, options.id, options.color);
      }
    } else {
      const hasNaN = false;
      const obj = { hasNaN};
      this.traverseCoor(coord, obj);
      if (obj.hasNaN) { return null; }

      if (type === 'LineString' || type === 'Polyline') {
        feature = this.createLine(coord, options);
      } else if (type === 'Polygon') {
        feature = this.createPolygon(coord, options);
      } else if (type === 'MultiPoint') {
        feature = this.createMultiPoint(coord, options);
      } else if (type === 'MultiLineString') {
        feature = this.createMultiLineString(coord, options);
      } else if (type === 'MultiPolygon') {
        feature = this.createMultiPolygon(coord, options);
      }

      let color = 'purple';
      // Changed to use color setup in selected asset for handlebars
      if (options.color) {color = options.color; }
      const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
      const url = (options.url ? options.url : '');
      const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
      const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');
      const properties: any = sclAssetLayers.createLineProperties(options.layer, options.name, color,
        options.id, options.tooltip, primaryMultiPopup, secondaryMultiPopup,
        options.layerDisplayOnly, relatedAssets, url);
      for (const p in properties) {
        if (properties.hasOwnProperty(p) && !feature.attributes.hasOwnProperty(p)) {
          feature.attributes[p] = properties[p];
        }
      }

      if (options.label) {
        const coord1 = feature.geometry.extent.center;
        feature.attributes.lb = this.createLabel(coord1.latitude, coord1.longitude, options.label, options.id, options.color);
      }
    }

    if (options.layer) {
      feature.attributes.layer = options.layer;
    }





    return feature;
  }


  setFeatureProperties(feature, properties) {
    if (!feature.attributes) { feature.attributes = {}; }
    if (properties) {
      for (const p in properties) {
        if (properties.hasOwnProperty(p)) {
          feature.attributes[p] =  properties[p];
        }
      }
    }
  }
  resetFeatureProperties(feature, properties) {
    feature.attributes = properties;
  }
  getFeatureProperty(feature, propertyName) {
    return feature.attributes[propertyName];
  }
  getFeatureProperties(feature, fieldNames) {
    const p = {};
    const pro = feature.attributes;
    for (let i = 0; i < fieldNames.length; i++) {
      p[fieldNames[i]] = pro[fieldNames[i]];
    }
    return p;
  }
  getFeatureId(feature) {
    return feature.attributes.id;
  }
  setFeatureId(feature, id) {
    feature.attributes.id = id;
  }
  getFeatureGeomType(feature) {
    const t = feature.attributes.type;
    return t;
  }

  getFeatureById(id) {
    let f = null;
    for (let i = 1; i < this.layerAssets.length; i++) {
      if (this.isHeatLayer(i)) { continue; }// heat map
      const graphics = this.layerAssets[i].graphicLayer.graphics;
      for (let j = 0; j < graphics.length; j++) {
        const fea = graphics.getItemAt(j);
        if (!fea || !fea.attributes || !fea.attributes.isAsset) {
          continue;
        }
        const fId = this.getFeatureId(fea);
        if (fId === id) {
          f = fea;
          break;
        }
      }
      if (f) {
        break;
      }
    }
    return f;
  }

  getFeatureByLayer(id, layerIndex) {
    if (layerIndex > this.layerAssets.length - 1) {
      return null;
    }
    if (this.isHeatLayer(layerIndex)) {
      return null; // heat map
    }
    let f = null;
    const graphics = this.layerAssets[this.layerIndexUser].graphicLayer.graphics;
    const len = graphics.length;
    for (let i = 0; i < len; i++) {
      const fea = graphics.getItemAt(i);
      const fId = this.getFeatureId(fea);
      if (fId === id) {
        f = fea;
        return;
      }
    }
    return f;
  }
  getFeatureByPixel(pixel) {
    return { feature: pixel.fea} ;
  }
  featureClone(fea, layerIndex) {
    const g = fea.clone();
    if (g.attributes.lb) {
      delete g.attributes.lb;
    }
    if (layerIndex === this.layerIndexUser && g.attributes
      && (g.attributes.type === 'Point' || g.attributes.type === 'MultiPoint') ) {
      const style = this.layerAssets[layerIndex].style;
      if (style.imageFileNo ) {
        g.symbol.url = style.imageFileNo;
      }
    }
    return g;
  }
  getEventByPixel(pixel) {
    // TO DO
  }
  getFeaturesCollection(options) {
    const lst = [];
    if (options.feature && options.feature.length > 0) {
      for (let i = 0; i < options.feature.length; i++) {
        lst.push({feature: options.feature[i]});

        const fId = options.feature[i].attributes.id;
        const zIndex = options.feature[i].attributes.zIndex;
        if (this.isHeatLayer(zIndex)) { continue; }// heat map

        const layer = this.layerAssets[zIndex].graphicLayer.graphics;
        layer.forEach((graphic) => {
          const att = graphic.attributes;
          let id0 = att.id;
          if (att && att.id && att.id !== fId) {
            if (att.id.indexOf('_') > -1 ) { id0 = att.id.split('_')[0]; }
            if (fId.indexOf(id0) > -1) {
              lst.push({feature: graphic });
            }
          }
        });
      }
    }

    return lst;
  }
  getFeaturesCollectionId(id, isClone) {
    const fs = [];
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (this.isHeatLayer(i)) { continue; }// heat map
      const graphics = this.layerAssets[i].graphicLayer.graphics;
      graphics.forEach((f) => {
        if (f.attributes && f.attributes.isAsset) {
          const fId = f.attributes.id;
          if (fId && fId.indexOf(id) > -1) {
            let isExist = false;
            for (let k = 0; k < fs.length; k++) {
              if (! fs[k].attributes ) { continue; }
              if (fs[k].attributes.id === fId) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              if (isClone) {
                const g = f.clone();
                if (g.attributes.lb) {
                  delete g.attributes.lb;
                }
                if (this.type === 1) {// sc-address-map
                  const style = this.layerAssets[this.layerIndexUser].style;
                  if (style.imageFileNo) {
                    g.symbol.url = style.imageFileNo;
                  }
                }
                fs.push(g);
              } else {
                fs.push(f);
              }
            }
          }
        }

      });
    }

    return fs;
  }

  updateStyleByFeature(layerClone, color, imageFileNo, anchor, style) {
    const currentStyle = cloneDeep(style);
    if (color) { currentStyle.color = color; }
    if (layerClone.fill) { currentStyle.fill = layerClone.fill; }
    if (layerClone.fillOpacity) { currentStyle.fillOpacity = layerClone.fillOpacity; }
    if (layerClone.lineCap) { currentStyle.lineCap = layerClone.lineCap; }
    if (layerClone.lineDash) { currentStyle.lineDash = layerClone.lineDash; }
    if (layerClone.lineWidth) { currentStyle.lineWidth = layerClone.lineWidth; }
    if (anchor) { currentStyle.imageAnchor = anchor; }
    if (imageFileNo) { currentStyle.imageFileNo = imageFileNo; }

    return currentStyle;
  }

  featureUpdateStyle(feature, style) {
    if (feature.attributes && style) {
      if (feature.attributes.type === 'Point' || feature.attributes.type === 'MultiPoint') {
        if (style.fill && style.fill.indexOf('{') > -1) { return; }

        if (style.color) { feature.symbol.color = style.color.toLowerCase(); }
        if (style.fill) { feature.symbol.color = style.fill.toLowerCase(); }

        //
        if (style.fillOpacity) { feature.symbol.color.a = style.fillOpacity; }
        if (feature.symbol.outline) {
          if (style.lineWidth) { feature.symbol.outline.width = style.lineWidth; }
          if (style.color) { feature.symbol.outline.color = style.color.toLowerCase(); }
        }

        if (style.imageAnchor) {
          if (feature.symbol.width) {
            feature.symbol.xoffset = feature.symbol.width * style.imageAnchor[0];
          }
          if (feature.symbol.height) {
            feature.symbol.yoffset = feature.symbol.height * style.imageAnchor[1];
          }
        }
      } else if (feature.attributes.type === 'LineString' || feature.attributes.type === 'MultiLineString' ||
        feature.attributes.type === 'Polyline') {
        if (style.color && style.color.indexOf('{') > -1) { return; }

        if (style.color) { feature.symbol.color = style.color.toLowerCase(); }
        if (style.lineWidth) { feature.symbol.width = style.lineWidth; }
        if (style.lineCap) { feature.symbol.cap = style.lineCap; }
        if (style.lineDash) { feature.symbol.style = 'dash'; }
      } else {// polygon
        if (style.fill && style.fill.indexOf('{') > -1) { return; }

        if (style.fill) { feature.symbol.color = style.fill.toLowerCase(); }
        if (style.fillOpacity && feature.symbol.color) { feature.symbol.color.a = style.fillOpacity; }
        if (!feature.symbol.outline) { feature.symbol.outline = { color: 'black', width: 1 }; }
        if (style.lineWidth) { feature.symbol.outline.width = style.lineWidth; }
        if (style.color) { feature.symbol.outline.color = style.color.toLowerCase(); }
        if (style.lineCap) { feature.symbol.outline.cap = style.lineCap; }
        if (style.lineDash) { feature.symbol.outline.style = 'dash'; }
      }
    }
  }

  addFeature(feature, layerIndex) {
    if (!feature) { return; }
    const style = this.layerAssets[layerIndex].style;

    if (!feature.attributes) { feature.attributes = {}; }
    feature.attributes.zIndex = 0;
    if (layerIndex && layerIndex < this.layerAssets.length) {
      feature.attributes.zIndex = layerIndex;
      if ( (style.color && style.color.indexOf('{') > -1) || (style.fill && style.fill.indexOf('{') > -1) ) {
        const handlebarStyle = this.updateStyleByFeature(feature.attributes.layer, feature.attributes.color, null, null, style);
        this.featureUpdateStyle(feature, handlebarStyle);
      } else {
        this.featureUpdateStyle(feature, style);
      }
      const graphics = this.layerAssets[layerIndex].graphicLayer.graphics;
      let isAdded = false;
      graphics.forEach((f, i) => {
        if (f.attributes.id === feature.attributes.id) {
          isAdded = true;
          return;
        }
      });
      if (!isAdded) {
        graphics.add(feature);
        if (feature.attributes.lb) {
          graphics.add(feature.attributes.lb);
        }
      }
    }
  }

  removeFeature(feature, layerIndex) {
    if (layerIndex) {
      if (layerIndex > this.layerAssets.length) { return; }
      if (feature.attributes.lb) {
        this.layerAssets[layerIndex].graphicLayer.graphics.remove(feature.attributes.lb);
      }
      this.layerAssets[layerIndex].graphicLayer.graphics.remove(feature);
    } else {
      const zIndex = feature.attributes.zIndex;
      if (feature.attributes.lb) {
        this.layerAssets[zIndex].graphicLayer.graphics.remove(feature.attributes.lb);
      }
      this.layerAssets[zIndex].graphicLayer.graphics.remove(feature);
    }
  }
  removeItemFromMap(id) {
    for (let i = 0; i < this.layerAssets.length; i++) {
      const layer = this.layerAssets[i].graphicLayer.graphics;
      if (!layer) { continue; }
      layer.forEach((graphic) => {
        const att = graphic.attributes; // graphic.graphic.attributes;
        if (att && att.id && att.id === id) {
          if (att.lb) {
            layer.remove(att.lb);
          }
          layer.remove(graphic); // layer.remove(graphic.graphic);
        }
      });
    }
  }
  getMapSize() {
    return [this.mapView.width, this.mapView.height];
  }

  getBoundingBox(options) {
    const extent = this.mapView.extent;
    if (extent) {
      const leftTop = this.lib.webMercatorUtils.xyToLngLat(extent.xmin, extent.ymin);
      const rightBottom = this.lib.webMercatorUtils.xyToLngLat(extent.xmax, extent.ymax);
      return { left: leftTop[0], top: leftTop[1], right: rightBottom[0], bottom: rightBottom[1], zoom: this.mapView.zoom};
    }
    return null;
  }


  addSearchAddress(apiKey, wrapper, cb) {
    // TO DO

  }

  clearAllFeatures() {
    // TO DO
  }

  clearAllFeaturesLayer(layerIndex) {
    if (layerIndex > this.layerAssets.length) { return; }
    this.layerAssets[layerIndex].graphicLayer.removeAll();
  }

  updateSize() {
    // TO DO
  }

  getLatLngFromPixel(pixel) {
    return [];
  }

  getPixelFromCoordinate(coordinate) {
    // TO DO
  }

  findFeatureByClick(evt, sType, assetSelectionsAvailable) {
    const features = evt.clickFeature;
    const coor = [ evt.event.mapPoint.longitude, evt.event.mapPoint.latitude ];

    const pixel = [ evt.event.x, evt.event.y ];

    const existedFeature = this.getFeaturesFromMap(features, pixel, sType, assetSelectionsAvailable);

    return { coor, pixel, features, existedFeature };
  }

  checkFeatureExist(layerIndex, id) {
    this.layerAssets[layerIndex].graphicLayer.graphics.find(function(fea) {
      return fea.attributes.id === id;
    });
  }

  _storeSelectedAsset(feature, isPrimary) {
    if (!this.selectedAssets) { this.selectedAssets = []; }
    const len = this.selectedAssets.length;

    if (!feature.attributes) { return; }
    const fId = feature.attributes.id;

    for (let i = 0; i < len; i++) {
      const iPro = this.selectedAssets[i].attributes;
      if (!iPro) { continue; }
      const iId = iPro.id;

      if (iId === fId) {
        if (isPrimary) {
          let isExist; isExist = this.checkFeatureExist(this.layerIndexPrimary, iId);
          if (!isExist) {
            this.addFeature(feature, this.layerIndexPrimary);
            this.setFeatureProperties(feature, {zIndex: this.layerIndexPrimary});
          }
        } else {
          let isExist;  isExist = this.checkFeatureExist(this.layerIndexSecondary, iId);
          if (!isExist) {
            this.addFeature(feature, this.layerIndexSecondary);
            this.setFeatureProperties(feature, {zIndex: this.layerIndexSecondary});
          }
        }

        return;
      }
    }
    this.selectedAssets.push(feature);
    if (isPrimary) {
      this.addFeature(feature, this.layerIndexPrimary);
    } else {
      this.addFeature(feature, this.layerIndexSecondary);
    }
  }

  storeSelectedAssets(feature, isPrimary) {
    this._storeSelectedAsset(feature, isPrimary);
  }
  removeSelectedAssetsById(id) {
    let fId = id;
    let mode = 'NA';
    if (fId && fId.indexOf('primary') > -1) { mode = 'primary'; } else if (fId && fId.indexOf('secondary') > -1) { mode = 'secondary'; }

    if (fId && fId.indexOf('_') > -1) { fId = fId.split('_')[0]; }
    const len = this.selectedAssets.length;
    for (let i = len - 1; i > -1; i--) {
      if (!this.selectedAssets[i].attributes) { continue; }
      const iId = this.selectedAssets[i].attributes.id;
      if ((iId && iId.indexOf(mode) > -1 && iId.indexOf(fId) > -1) || iId === fId ) {
        this.selectedAssets.splice(i, 1);
        this.removeItemFromMap(iId);
      }
    }
  }
  removeLayerFeatures() {
    for (let i = 1; i < this.layerAssets.length; i++) {
      if (this.isHeatLayer(i)) {
        continue; // heat map
      }
      this.layerAssets[i].graphicLayer.graphics.removeAll();
    }
  }
  // copy from sclAssetLayers.removeUnselectedAsset
  removeUnselectedAsset(assets, unSelectedAssetIds, type) {
    // TO DO
  }
  updateLayers(pLayerAssets) {
    // remove feature in all layers
    this.removeLayerFeatures();
    // remove old layers
    for (let i = 1; i < this.layerAssets.length; i++) {
      this.map.remove(this.layerAssets[i].graphicLayer);
    }

    // add new layers
    const obj = {layerAssets: pLayerAssets};
    this.createLayers(obj);
    for (let i = 1; i < this.layerAssets.length; i++) {
      this.map.add(this.layerAssets[i].graphicLayer, i);
    }
  }

  // ************** use for psma layer reverse function *******************************************
  psmaStyleFunction() {
    // No need
  }
  psmaCreateLayer(psmaPoints) {
    if (!this.psmaReverse) {
      this.psmaReverse = {};

      for (let i = 0; i < psmaPoints.length; i++) {
        this.addFeature(psmaPoints[i], this.layerIndexAddress); // 13835
      }

      this.psmaReverse.psmaSourceVector = this.layerAssets[this.layerIndexAddress]; // 13835
      this.psmaReverse.psmaLayer = this.layerAssets[this.layerIndexAddress]; // 13835
    }

    return this.psmaReverse;
  }
  psmaCreatePoint(coor, properties, psmaPoints) {
    const symbol = {
      type: 'simple-marker',
      color: 'rgba(255, 127, 39, 1)' ,  // orange
      outline: {
        color: 'rgba(255, 0, 0, 1)', // red
        width: 1
      },
      size: 4
    };
    const circleGeom = new this.lib.Circle({
      center: coor,
      radius: 0.1
    });
    const point = new this.lib.Graphic({
      geometry: circleGeom,
      symbol
    });
    this.setFeatureProperties(point, properties);

    this.addFeature(point, this.layerIndexAddress);

    psmaPoints.push(point);
    return psmaPoints;
  }
  psmaCreatePointClick(coor, radius, psmaPoints) {
    // let symbol = this.setupPointSymbol({type: 'Polygon'})
    const symbol = {
      type: 'simple-fill',
      color: 'rgba(255,255,255,0.4)',  // white, opacity 40%
      outline: {
        color: '#3399CC', // blue
        width: 1
      }
    };
    const center = new this.lib.Point({latitude: coor[1], longitude: coor[0], spatialReference: this.mapView.spatialReference});
    const circleGeom = new this.lib.Circle({
      center,
      radius
    });
    const circle = new this.lib.Graphic({
      geometry: circleGeom,
      symbol
    });

    this.addFeature(circle, this.layerIndexAddress);

    psmaPoints.push(this.marker);
    psmaPoints.push(circle);

    return psmaPoints;
  }
  psmaRemovePoint(psmaPoints, psmaSourceVector) {
    for (let i = 0; i < psmaPoints.length; ++i) {
      // if(!psmaPoints[i]) continue;
      psmaSourceVector.graphicLayer.graphics.remove(psmaPoints[i]);
    }

    return { psmaPoints, psmaSourceVector };
  }
  rad(x) {
    return x * Math.PI / 180;
  }
  psmaDistanceCoords(coorA, coorB) {
    const R = 6378137; // Earth’s mean radius in meter
    const dLat = this.rad(coorB[1] - coorA[1]);
    const dLong = this.rad(coorB[0] - coorA[0]);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(coorA[1])) * Math.cos(this.rad(coorB[1])) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d; // returns the distance in meter
  }


  // copy from this.sclUtilMapService.positionView
  positionView(lat, lon, zoom, EPSG) {
    lat = typeof lat !== 'undefined' ? lat : 0;
    lon = typeof lon !== 'undefined' ? lon : 0;
    zoom = typeof zoom !== 'undefined' ? zoom : 2;
    EPSG = typeof EPSG !== 'undefined' ? EPSG : 'EPSG:3857';
    this.mapView.zoom = zoom;      // This will trigger a zoom_changed on the map
    this.mapView.center = [lon, lat];
  }

  //
  setCenterMapViewByCoordinates(bbox) {
    const xmin = bbox[0][0]; const ymin = bbox[0][1]; const xmax = bbox[1][0]; const ymax = bbox[1][1];
    const ext = new this.lib.Extent({
      xmin,
      ymin,
      xmax,
      ymax
    });
    this.mapView.extent = ext;  // Updates the view without animation
  }
  // 15262
  setCenter(lat, lon) {
    this.mapView.center = [lon, lat];
  }
}
